import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import {
  ConfirmationService,
  MenuItem,
  MessageService,
  PrimeIcons,
} from "primeng/api";
import { NGXLogger } from "ngx-logger";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ActivatedRoute, Router } from "@angular/router";
import { OdaAtFirestore } from "src/app/models/odaAtFirestore.model";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { environment } from "src/environments/environment";
import { onSnapshot } from "firebase/firestore";
import { UtilService } from "src/app/services/util.service";
import { Menu } from "primeng/menu";

import { ExcelService } from "src/app/services/excelService.service";
import {
  FiltroPratica,
  PraticaFlowdy2_Firestore,
} from "src/app/models/praticaFirestore.model";
import { StiliService } from "src/app/services/stili.service";
import { UserService } from "src/app/services/user.service";
import {
  deleteObject,
  getBlob,
  getStorage,
  listAll,
  ref,
} from "firebase/storage";
import { saveAs } from "file-saver";
import { PraticheService } from "src/app/services/pratiche.service";
import { DialogNoteReworkFase1 } from "../../shared/note-rework-fase1/note-rework.component";
import * as JSZip from "jszip";
import { ComunicaBocciatura } from "../../shared/comunica-bocciatura/comunica_bocciatura.component";
import { DialogAccettazioneInvioInfratel } from "../../shared/comunica-accettazione/accettazione.component";
import { Location } from "@angular/common";
import { Utente } from "src/app/models/utente.model";
import { OdaService } from "src/app/services/oda.service";
import { ListeService } from "src/app/services/liste.service";
import { StoricoPraticaComponent } from "../../shared/storico/storico-pratica.component";
import { DialogCaricaFileFase2 } from "../../shared/carica-file/carica-file.component";
import { DialogCaricaVerbaleFase2 } from "../../shared/carica-verbale-fase2/carica-verbale_fase2.component";
import { DialogComunicaEsitoAppuntamentoFase2 } from "../../shared/esito-appuntamento-fase2/esito_appuntamento_fase2.component";
import { DialogComunicaDataAppuntamentoFase2 } from "../../shared/data-appuntamento-fase2/data_appuntamento_fase2.component";
import { DialogCaricaFoto } from "../../shared/carica-foto/carica-foto.component";
import { DialogNoteReworkFase2 } from "../../shared/note-rework-fase2/note-rework.component";
import { Observable } from "rxjs";
import { DialogCaricaPermessoFase2 } from "../../shared/carica-permesso/carica-permesso_fase2.component";
import { DialogVerificaConsegnaFase2 } from "../../shared/verifica-consegna-fase2/verifica_consegna_fase2.component";
import { v4 as uuidv4 } from "uuid";
import { ImportLog_Firestore } from "src/app/models/firestore/importLogFirestore.model";
import { DialogInvioInfratel } from "../../shared/comunica-invio-infratel/invio-infratel.component";
import { DialogPresidioTIMRifiutaPratica } from "../../shared/presidioTIM-rifiuta-pratica/presidioTIM_rifiuta_pratica.component";
import { Impresa } from "src/app/models/impresa.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { DialogModificaDataAttivazione } from "../../shared/modifica-data-attivazione/modifica_data_attivazione.component";
import { DialogModificaStato } from "../../shared/modifica-stato/modifica_stato.component";
import { StoricoNotePraticaComponent } from "../../shared/note-pratica/note-pratica.component";
import { CreaNotaPraticaComponent } from "../../shared/crea-note-pratica/crea-nota-pratica.component";
import { DialogAssegnaOdaFase1 } from "../../shared/assegna-oda/assegna-oda.component";
import { DialogCaricaAltriFileFase2 } from "../../shared/carica-altri-file-fase2/carica-altri-file.component";

declare const CSVBoxImporter: any;

@Component({
  templateUrl: "./fase2.bando2.component.html",
  styleUrls: ["./fase2.bando2.component.css"],
  providers: [DialogService, ConfirmationService],
})
export class PraticheFase2Bando2Component implements OnInit, OnDestroy {
  protected isLoadingResults: boolean = false;
  protected mostraPraticheCompletate: boolean = false;

  protected showDeliverConfirmation: boolean = false;
  protected showAnnullaConsegnaConfirmation: boolean = false;
  protected showEliminaFilePINGConfirmation: boolean = false;
  protected showEliminaFileSPEEDConfirmation: boolean = false;
  protected showEliminaFileFotoCPEConfirmation: boolean = false;
  protected showEliminaFileAltriConfirmation: boolean = false;
  protected showSovrascritturaFotoCPEConfirmation: boolean = false;
  protected showDettagliPratica: boolean = false;

  protected showResettaPratica: boolean = false;
  protected showFase1Approvata: boolean = false;
  protected showEliminaShowFase2Confirmation: boolean = false;

  public isAdmin: boolean = false;
  public isSuperAdmin: boolean = false;
  public isPresidioSF: boolean = false;
  public isPresidioTIM: boolean = false;
  public isDirigenteFirmaVerbali: boolean = false;
  public isDirigenteFirmaPacchetti: boolean = false;
  public isPM: boolean = false;
  public isContabile: boolean = false;
  public isImpresa: boolean = false;
  public isDemo: boolean = false;
  protected pratiche: PraticaFlowdy2_Firestore[];
  protected pratichePerPresidioTIM: PraticaFlowdy2_Firestore[];
  protected praticheFiltrate: PraticaFlowdy2_Firestore[];
  protected selectedPratica: PraticaFlowdy2_Firestore;

  @ViewChild("menuAzioni", { static: true }) azioniMenu: Menu;
  @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered: Menu;

  protected menuAzioniItems!: MenuItem[];
  private _filtroPratiche!: FiltroPratica;

  get filtroPratiche(): FiltroPratica {
    return this._filtroPratiche;
  }

  set filtroPratiche(value: FiltroPratica) {
    this._filtroPratiche = value;
  }

  private collection_pratiche: string =
    environment.firebase.collection_pratiche;
  private collection_importLog: string =
    environment.firebase.collection_import_log;

  private ref: DynamicDialogRef;

  protected filterTabellaIsSet: boolean = false;
  protected filterIsSet: boolean = false;
  protected filtroInLavorazione: boolean = false;
  protected filtroLotto: String;
  protected filtroStatoInfratel: String;
  protected filtroOda: String;
  protected filtroDaPagare: boolean = false;
  protected filtroLottoPerFase: String;
  protected filtroStatoFlowdy: String;

  protected filtroImpresa: String;
  protected ragioneSocialeImpresa: String = "";
  protected statoAttivazione: String = "";
  protected filtroStatoAttivazione: String;
  protected paginaBack: string = null;

  protected filtroPratica: String;
  protected filtroRegione: String;
  protected filtroTipoSedeEffettivaApp: String;

  private csvbox_licenseKey_comunicaEsitiConsegnaBando2: string =
    environment.csvBox.secret_comunicaEsitiConsegnaFase2;
  private csvbox_licenseKey_importaEsitoControlloTIMSupport: string =
    environment.csvBox.secret_importaEsitoControlloTIMSupport;
  private csvbox_importer_comunicaEsitiConsegnaBando2: any;
  private csvbox_importer_esitiControlloTIMSupport: any;

  private importID: string;

  protected imprese: Impresa[] = [];

  @ViewChild("praticheDT", { static: true }) praticheDT: any;

  constructor(
    private logger: NGXLogger,
    public firestore: AngularFirestore,
    public utilService: UtilService,
    protected stiliService: StiliService,
    private userService: UserService,
    public dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private praticheService: PraticheService,
    private excelService: ExcelService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private odaService: OdaService,
    protected listeService: ListeService,
    private aziendeService: ImpreseService,
    private router: Router,
  ) {
    this._filtroPratiche = {};
    this.setUserRole();
    this.loadImprese();
  }

  loadImprese() {
    this.aziendeService.getByBando("2").subscribe((aziende) => {
      this.imprese = aziende;
    });
  }

  ngOnDestroy(): void {}

  ngOnInit() {
    this.initCSVBox();
    const urlParamInLavorazione =
      this.activatedRoute.snapshot.paramMap.get("lavorazione");
    const urlParamLotto = this.activatedRoute.snapshot.paramMap.get("lotto");
    const urlParamCodiceInfratel =
      this.activatedRoute.snapshot.paramMap.get("stato");
    const urlParamOda = this.activatedRoute.snapshot.paramMap.get("oda");
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.filtroDaPagare = params.get("da-pagare") === "true";
      this.filtroLottoPerFase = params.get("lotto");
      this.filtroInLavorazione = params.get("in-lavorazione") === "true";
      this.filtroImpresa = params.get("impresa");
      this.filtroStatoAttivazione = params.get("statoAttivazione");
      this.filtroPratica = params.get("pratica");
      this.filtroStatoFlowdy = params.get("stato-flowdy");
      this.filtroRegione = params.get("regione");
      this.paginaBack = params.get("from");
      this.filtroTipoSedeEffettivaApp = params.get("tipoSedeEffettivaApp");
      if (this.filtroStatoAttivazione) {
        this.filterIsSet = true;
        switch (this.filtroStatoAttivazione) {
          case "noAppuntamentoMancaPF_noNTW":
            this.statoAttivazione = "PF IN ATTESA (NO NTW)";
            break;
          case "noAppuntamentoMancaPF_conNTW":
            this.statoAttivazione = "PF IN ATTESA (CON NTW)";
            break;
          case "noAppuntamentoMancaPF":
            this.statoAttivazione = "SENZA APPUNTAMENTO (PF IN ATTESA)";
            break;
          case "noAppuntamentoPFPronto":
            this.statoAttivazione = "SENZA APPUNTAMENTO (PF PRONTO)";
            break;
          case "appuntamentoFissato":
            this.statoAttivazione = "APPUNTAMENTO PIANIFICATO";
            break;
          case "appuntamentoScaduto":
            this.statoAttivazione = "APPUNTAMENTO SCADUTO";
            break;
          case "attivazioneKO":
            this.statoAttivazione = "ATTIVAZIONE KO";
            break;
          case "attivazioneOK":
            this.statoAttivazione = "ATTIVAZIONE OK";
            break;
          case "installazioneOK":
            this.statoAttivazione = "INSTALLAZIONE OK";
            break;
          default:
            break;
        }
      }
      if (this.filtroImpresa) {
        this.ragioneSocialeImpresa = params.get("ragioneSocialeImpresa");
      }

      if (this.filtroTipoSedeEffettivaApp) {
        const tipo = this.filtroTipoSedeEffettivaApp.toString().trim();
        if (tipo.length > 0) {
          if (!this._filtroPratiche.tipo) {
            this._filtroPratiche.tipo = [];
          }
          if (this._filtroPratiche.tipo.indexOf(tipo) === -1) {
            this._filtroPratiche.tipo.push(tipo);
          }
          this.filterIsSet = true;
        }
      }
    });
    if (this.filtroInLavorazione || this.filtroImpresa || this.filtroPratica) {
      this.filterIsSet = true;
    }

    if (urlParamLotto) {
      this.filtroLotto = urlParamLotto;
      this.filterIsSet = true;
    } else if (urlParamCodiceInfratel) {
      this.filtroStatoInfratel = urlParamCodiceInfratel;
      this.filterIsSet = true;
    } else if (urlParamOda) {
      this.filtroOda = urlParamOda;
      this.filterIsSet = true;
    } else if (this.filtroStatoFlowdy) {
      this.filtroStatoFlowdy = this.filtroStatoFlowdy.toUpperCase();
      this.filterIsSet = true;
    }

    this.loadPratiche();
  }

  mostraInfo(pratica: PraticaFlowdy2_Firestore) {
    this.selectedPratica = pratica;
    this.showDettagliPratica = true;
  }
  checkIfInfoAreAvailable(pratica: PraticaFlowdy2_Firestore): boolean {
    if (pratica.sdfPrincipale || pratica.impresaFC) {
      return true;
    }
    return false;
  }

  initCSVBox() {
    this.csvbox_importer_comunicaEsitiConsegnaBando2 = new CSVBoxImporter(
      this.csvbox_licenseKey_comunicaEsitiConsegnaBando2,
      {},
      (result: boolean, data: any) => {
        if (result) {
          this.readImportLog();
        } else {
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            detail:
              "Errore in fase di INSERIMENTO DEGLI ESITI DELLA CONSEGNA DI FASE 2 delle pratiche del bando 2",
            life: 10000,
          });
        }
      },
    );
    this.csvbox_importer_esitiControlloTIMSupport = new CSVBoxImporter(
      this.csvbox_licenseKey_importaEsitoControlloTIMSupport,
      {},
      (result: boolean, data: any) => {
        if (result) {
          this.readImportLog();
        } else {
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            detail:
              "Errore in fase di INSERIMENTO DEGLI ESITI DEL CONTROLO DI TIM SUPPORT delle pratiche del bando 2",
            life: 10000,
          });
        }
      },
    );

    this.csvbox_importer_comunicaEsitiConsegnaBando2.setUser({
      user_id: "default123",
    });

    this.csvbox_importer_comunicaEsitiConsegnaBando2.language = "it";
  }

  readImportLog() {
    const collectionRef = this.firestore.collection(
      this.collection_importLog,
    ).ref;
    let queryErrori;
    queryErrori = collectionRef.where("id", "==", this.importID);

    onSnapshot(queryErrori, (qs) => {
      this.isLoadingResults = false;
      qs.forEach((doc) => {
        let log: ImportLog_Firestore = doc.data() as ImportLog_Firestore;
        if (!log.errori || log.errori.length == 0) {
          if (!log.warning || log.warning.length == 0) {
            if (log.numeroRecordNonProcessati != 0) {
              if (log.numeroRecordNonProcessati == 1) {
                this.messageService.add({
                  severity: "success",
                  summary: "",
                  detail:
                    "Delle " +
                    log.numeroTotaleRecord +
                    " pratiche presenti nel file " +
                    log.numeroRecordProcessati +
                    " sono state processate con successo mentre " +
                    log.numeroRecordNonProcessati +
                    " non è stata processata",
                  life: 10000,
                });
              } else {
                this.messageService.add({
                  severity: "success",
                  summary: "",
                  detail:
                    "Delle " +
                    log.numeroTotaleRecord +
                    " pratiche presenti nel file " +
                    log.numeroRecordProcessati +
                    " sono state processate con successo mentre " +
                    log.numeroRecordNonProcessati +
                    " non sono state processate",
                  life: 10000,
                });
              }
            } else {
              this.messageService.add({
                severity: "success",
                summary: "",
                detail:
                  "Tutte le " +
                  log.numeroTotaleRecord +
                  " pratiche presenti nel file sono state processate con successo",
                life: 10000,
              });
            }
          } else {
            this.messageService.add({
              severity: "warn",
              summary: "Warning",
              detail:
                "Il caricamento degli esiti della consegna ad INFRATEL della FASE 1 si è concluso con " +
                log.numeroRecordNonProcessati +
                " warning",
              life: 10000,
            });
          }
        } else {
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            detail:
              "Il caricamento degli esiti della consegna ad INFRATEL della FASE si è concluso con " +
              log.numeroRecordNonProcessati +
              " errori",
            life: 10000,
          });
        }
      });
    });
  }

  async openCaricaAzioni(
    event: any,
    pratica: PraticaFlowdy2_Firestore,
  ): Promise<void> {
    this.selectedPratica = pratica;
    this.loadAzioni(event, pratica);
    this.azioniMenuTiered.toggle(event);
  }

  getPraticaPrincipaleDiUnaColocata(
    cuiPrincipale: string,
  ): PraticaFlowdy2_Firestore {
    return this.pratichePerPresidioTIM.find(
      (pratica) => pratica.cui === cuiPrincipale,
    );
  }

  getPraticheColocateDiUnaPrincipale(
    cuiPrincipale: string,
  ): PraticaFlowdy2_Firestore[] {
    return this.pratiche.filter(
      (pratica) => pratica.colocataScuolaPrincipale === cuiPrincipale,
    );
  }

  checkCodiceInvioColocate(pratica: PraticaFlowdy2_Firestore): boolean {
    let sameCodiceInvio = true;
    if (pratica.colocataRuolo === "SECONDARIA") {
      //this.logger.info("-> checkCodiceInvioColocate "+ pratica.cui + " secondaria della principale " + pratica.colocataScuolaPrincipale);

      let principale: PraticaFlowdy2_Firestore =
        this.getPraticaPrincipaleDiUnaColocata(
          pratica.colocataScuolaPrincipale,
        );
      if (principale) {
        // this.logger.info("-> checkCodiceInvioColocate "+ pratica.cui + " principale " + principale.cui);
        //  this.logger.info("-> checkCodiceInvioColocate "+ pratica.cui + " principale " + principale.codiceInvio + " Vs secondaria "+ pratica.codiceInvio);

        if (principale.codiceInvio && pratica.codiceInvio) {
          if (principale && principale.codiceInvio !== pratica.codiceInvio) {
            sameCodiceInvio = false;
          }
        } else {
          sameCodiceInvio = false;
        }
      }
    } else if (pratica.colocataRuolo === "PRINCIPALE") {
      let secondarie: PraticaFlowdy2_Firestore[] =
        this.getPraticheColocateDiUnaPrincipale(pratica.cui);
      secondarie.forEach((secondaria) => {
        // this.logger.info("-> checkCodiceInvioColocate "+ pratica.cui + " CONFRONTO CODICI: " + pratica.codiceInvio+ " VS "+secondaria.codiceInvio);

        if (secondaria.codiceInvio !== pratica.codiceInvio) {
          sameCodiceInvio = false;
        }
      });
    }
    //this.logger.info("-> checkCodiceInvioColocate "+ pratica.cui + " RISULTATO FINALE -> "+ sameCodiceInvio);

    return sameCodiceInvio;
  }

  checkCodiceInvioUgualeColocate(pratica: PraticaFlowdy2_Firestore): boolean {
    let sameCodiceInvio = true;

    if (pratica.colocataRuolo === "SECONDARIA") {
      //this.logger.info("> checkCodiceInvioUgualeColocate su pratica "+ pratica.cui + " "+ pratica.colocataRuolo);

      let principale: PraticaFlowdy2_Firestore =
        this.getPraticaPrincipaleDiUnaColocata(
          pratica.colocataScuolaPrincipale,
        );
      if (principale) {
        //this.logger.info("> checkCodiceInvioUgualeColocate su pratica "+ pratica.cui + " "+ pratica.colocataRuolo + " -> "+ pratica.codiceInvio + " vs "+ principale.codiceInvio);

        if (principale.codiceInvio && pratica.codiceInvio) {
          if (principale && principale.codiceInvio !== pratica.codiceInvio) {
            sameCodiceInvio = false;
          }
        } else {
          sameCodiceInvio = false;
        }
      }
    } else if (pratica.colocataRuolo === "PRINCIPALE") {
      //this.logger.info("> checkCodiceInvioUgualeColocate su pratica "+ pratica.cui + " "+ pratica.colocataRuolo);

      let secondarie: PraticaFlowdy2_Firestore[] =
        this.getPraticheColocateDiUnaPrincipale(pratica.cui);
      secondarie.forEach((secondaria) => {
        if (secondaria.codiceInvio !== pratica.codiceInvio) {
          sameCodiceInvio = false;
        }
      });
    }
    return sameCodiceInvio;
  }

  checkShowActionIcons(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      pratica.statoFlowdyFase2 === "ASSEGNATA" ||
      pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" ||
      pratica.statoFlowdyFase2 === "APPUNTAMENTO MANCATO" ||
      pratica.statoFlowdyFase2 === "CONTROLLO TIM SUPPORT OK" ||
      pratica.statoFlowdyFase2 === "INSTALLAZIONE EFFETTUATA" ||
      pratica.statoFlowdyFase2 === "RESPINTA" ||
      pratica.statoFlowdyFase2 === "IN REWORK AZIENDA" ||
      pratica.statoFlowdyFase2 === "PREVENTIVO IN ATTESA"
    ) {
      return true;
    }
    return false;
  }
  assegnaODA(pratica: PraticaFlowdy2_Firestore) {
    const localizzazione: string =
      pratica.cui.split("-")[1] === "LIG"
        ? "LIGURIA"
        : pratica.cui.split("-")[1] === "PIE"
          ? "PIEMONTE"
          : "TOSCANA";
    this.isLoadingResults = true;
    this.odaService
      .getDisponibiliPerAzienda(
        pratica.idAzienda,
        pratica.bando,
        localizzazione,
      )
      .subscribe({
        next: (v) => {
          // this.logger.info(JSON.stringify(v));
          if (!v || v.length == 0) {
            this.isLoadingResults = false;
            this.messageService.add({
              life: 10000,
              severity: "warn",
              summary: "ATTENZIONE",
              detail:
                "Nessun ODA disponibile per l'azienda " +
                pratica.azienda +
                " ed il bando 1",
            });
          } else {
            this.isLoadingResults = false;
            this.ref = this.dialogService.open(DialogAssegnaOdaFase1, {
              data: {
                pratica: pratica,
                listaOda: v,
              },
              header: "Assegna ODA alla pratica " + pratica.cui.toUpperCase(),
              width: "50%",
              height: "55%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.ref.onClose.subscribe((confermaAssegnazioneODA) => {
              if (confermaAssegnazioneODA && confermaAssegnazioneODA.success) {
                this.messageService.add({
                  severity: "success",
                  summary: "",
                  detail: "ODA assegnato con successo!",
                  life: 3000,
                });
                this.loadPratiche();
              }
            });
          }
        },
        error: (e) => {
          this.messageService.add({
            life: 10000,
            severity: "error",
            summary: "Errore",
            detail:
              "Errore in fase di recupero dell'oda da assegnare alla pratica",
          });
          this.isLoadingResults = false;
        },
        complete: () => {
          this.isLoadingResults = false;
        },
      });
  }

  loadAzioni(event: any, pratica: PraticaFlowdy2_Firestore) {
    this.menuAzioniItems = [];
    this.menuAzioniItems.push({
      label: "Storico",
      icon: PrimeIcons.HISTORY,
      style: { "font-size": "12px" },
      command: () => this.openStoricoPratica(pratica),
    });

    if (this.isImpresa) {
      //IMPRESA
      //BANDO2 OPERO SOLO SULLE PRINCIPALI IN CASO DI COLOCAZIONE
      if (
        !pratica.colocata ||
        (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
        (pratica.colocata &&
          pratica.colocataRuolo === "SECONDARIA" &&
          !this.checkCodiceInvioColocate(pratica))
      ) {
      }

      if (pratica.statoFlowdyFase1 === "DA ASSEGNARE") {
        this.menuAzioniItems.push({
          label: "Prendi in carico",
          icon: "icona-sf_in_carico",
          style: { "font-weight": "bold", "font-size": "12px" },
          command: () => this.openPrendiInCarico(pratica),
        });
      }

      if (
        pratica.statoPF === "PRONTO" ||
        pratica.statoPF === "ROUTER INSTALLATO" ||
        pratica.statoPF === "SEDE ATTIVATA"
      ) {
        //SOLO SU PRATICHE CON PF PRONTO
        if (
          pratica.statoFlowdyFase2 === "ASSEGNATA" ||
          pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" ||
          pratica.statoFlowdyFase2 === "APPUNTAMENTO MANCATO"
        ) {
          if (pratica.servePermessoEntePubblico && pratica.permessoUploaded) {
            this.menuAzioniItems.push({
              label: "Scarica permesso",
              icon: PrimeIcons.DOWNLOAD,
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.scaricaPermesso(pratica),
            });
          }
        }

        if (
          (!pratica.servePermessoEntePubblico ||
            (pratica.servePermessoEntePubblico && pratica.permessoUploaded)) &&
          pratica.statoPF === "PRONTO"
        ) //&& (pratica.statoFlowdyFase2 !=='CONSEGNATA' && pratica.statoFlowdyFase2 !=='PUBBLICATA' && pratica.statoFlowdyFase2 !=='APPROVATA') )
        {
          //this.logger.info(pratica.statoFlowdyFase2 + " Vs " + pratica.statoPF);
          if (
            pratica.statoFlowdyFase2 !== "CONSEGNATA" &&
            pratica.statoFlowdyFase2 !== "PUBBLICATA" &&
            pratica.statoFlowdyFase2 !== "APPROVATA"
          ) {
            let itemsAppuntamento: any[] = [];
            let labelComunicaData = "Comunica Data";

            if (
              pratica.dataAppuntamentoFase2 &&
              pratica.statoFlowdyFase2 !== "ATTIVAZIONE KO FO"
            ) {
              labelComunicaData = "Cambia data";
            }
            if (
              pratica.statoFlowdyFase2 === "ATTIVAZIONE KO FO" ||
              pratica.statoFlowdyFase2 === "ATTIVAZIONE KO CPE"
            ) {
              labelComunicaData = "Comunica Nuova Data";
            }

            itemsAppuntamento.push({
              label: labelComunicaData,
              icon: "icona-comunica-data",
              style: { "font-size": "12px" },
              command: () => this.comunicaDataAppuntamento(pratica),
            });
            if (
              pratica.dataAppuntamentoFase2 &&
              pratica.statoFlowdyFase2 !== "ATTIVAZIONE KO FO" &&
              pratica.statoFlowdyFase2 !== "ATTIVAZIONE KO CPE"
            ) {
              itemsAppuntamento.push({
                label: "Esito Installazione",
                icon: "icona-comunica-esito",
                style: { "font-size": "12px" },
                command: () => this.comunicaEsitoAppuntamento(pratica),
              });
            }
            this.menuAzioniItems.push({
              label: "Appuntamento",
              icon: PrimeIcons.CALENDAR,
              style: { "font-weight": "bold", "font-size": "12px" },
              items: itemsAppuntamento,
            });
          } else {
            // this.logger.info("OK");
          }
        } else {
          //this.logger.info("---DOVREBBE ENTRARE QUI");
        }
        //}

        if (pratica.statoFlowdyFase2 === "INSTALLAZIONE KO") {
          let itemsAppuntamento: any[] = [];
          itemsAppuntamento.push({
            label: "Comunica Nuova Data",
            icon: "icona-comunica-data",
            style: { "font-size": "12px" },
            command: () => this.comunicaDataAppuntamento(pratica),
          });
          if (pratica.dataAppuntamentoFase2) {
            itemsAppuntamento.push({
              label: "Esito Installazione",
              icon: "icona-comunica-esito",
              style: { "font-size": "12px" },
              command: () => this.comunicaEsitoAppuntamento(pratica),
            });
          }
          this.menuAzioniItems.push({
            label: "Appuntamento",
            icon: PrimeIcons.CALENDAR,
            style: { "font-weight": "bold", "font-size": "12px" },
            items: itemsAppuntamento,
          });
        }
        if (
          pratica.statoFlowdyFase2 === "INSTALLAZIONE EFFETTUATA" ||
          pratica.statoFlowdyFase2 === "INSTALLAZIONE KO"
        ) {
          if (pratica.servePermessoEntePubblico) {
            this.menuAzioniItems.push({
              label: "Scarica permesso",
              icon: PrimeIcons.DOWNLOAD,
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.scaricaPermesso(pratica),
            });
          }
        }

        if (
          pratica.statoFlowdyFase2 === "CONTROLLO TIM SUPPORT OK" ||
          pratica.statoFlowdyFase2 === "INSTALLAZIONE EFFETTUATA" ||
          pratica.statoFlowdyFase2 === "IN REWORK AZIENDA"
        ) {
          let itemsPingTest: any[] = [
            {
              label: "Carica",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () => this.caricaFile(pratica, "PING TEST"),
            },
          ];
          if (pratica.filePingTestUploaded) {
            itemsPingTest.push(
              {
                label: "Scarica",
                icon: "pi pi-download",
                style: { "font-size": "12px" },
                command: () => this.scaricaFile(pratica, "PING_TEST", false),
              },
              {
                label: "Elimina tutti",
                icon: PrimeIcons.ERASER,
                style: { "font-weight": "bold", "font-size": "12px" },
                command: () =>
                  this.chiediEliminazioneTuttiFileCaricati(
                    pratica,
                    "PING_TEST",
                  ),
              },
            );
          }
          let itemsSpeedTest: any[] = [
            {
              label: "Carica",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () => this.caricaFile(pratica, "SPEED TEST"),
            },
          ];
          if (pratica.fileSpeedTestUploaded) {
            itemsSpeedTest.push(
              {
                label: "Scarica",
                icon: "pi pi-download",
                style: { "font-size": "12px" },
                command: () => this.scaricaFile(pratica, "SPEED_TEST", false),
              },
              {
                label: "Elimina tutti",
                icon: PrimeIcons.ERASER,
                style: { "font-weight": "bold", "font-size": "12px" },
                command: () =>
                  this.chiediEliminazioneTuttiFileCaricati(
                    pratica,
                    "SPEED_TEST",
                  ),
              },
            );
          }

          let itemsVerbaleAttivazione: any[] = [
            {
              label: "Carica",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () => this.caricaDocumento(pratica, "ATTIVAZIONE"),
            },
          ];
          if (pratica.fileVerbaleAttivazioneUploaded) {
            itemsVerbaleAttivazione.push({
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "12px" },
              command: () => this.scaricaDoc(pratica),
            });
          }
          let itemsDocumenti: any[] = [
            {
              label: "Verbale di Attivazione",
              style: { "font-size": "12px" },
              items: itemsVerbaleAttivazione,
            },
          ];
          let itemsFotoCPE: any[] = [
            {
              label: "Carica",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () =>
                pratica.fotoCPEUploaded
                  ? this.chiediSovrascritturaFotoCPE(pratica)
                  : this.caricaFotoCPE(pratica),
            },
            {
              label: "Elimina tutte",
              icon: PrimeIcons.ERASER,
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () =>
                this.chiediEliminazioneTuttiFileCaricati(pratica, "CPE"),
            },
          ];
          if (pratica.fotoCPEUploaded) {
            itemsFotoCPE.push({
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "12px" },
              command: () => this.scaricaFotoCPE(pratica, false),
            });
          }

          let itemsFile: any[] = [
            {
              label: "Ping",
              style: { "font-size": "12px" },
              items: itemsPingTest,
            },
            {
              label: "Speed",
              style: { "font-size": "12px" },
              items: itemsSpeedTest,
            },
          ];
          let itemsAltro: any[] = [];
          itemsAltro.push({
            label: "Carica",
            icon: "pi pi-upload",
            style: { "font-size": "11px" },
            command: () => this.caricaFile(pratica, "ALTRO"),
          });
          if (pratica.fileAltriUploadedFase2) {
            itemsAltro.push(
              {
                label: "Scarica",
                icon: "pi pi-download",
                style: { "font-size": "11px" },
                command: () => this.scaricaFileAltri(pratica),
              },
              {
                label: "Elimina",
                icon: PrimeIcons.ERASER,
                style: { "font-weight": "bold", "font-size": "12px" },
                command: () =>
                  this.chiediEliminazioneTuttiAltriFileCaricati(pratica),
              },
            );
          }
          let allegatiFase2: any[] = [
            {
              label: "Test",
              icon: "icona-files",
              style: { "font-size": "12px" },
              items: itemsFile,
            },
            {
              label: "Foto CPE",
              icon: "icona-foto-cpe",
              style: { "font-size": "12px" },
              items: itemsFotoCPE,
            },
            {
              label: "Verbale",
              icon: "icona-docs",
              style: { "font-size": "12px" },
              items: itemsVerbaleAttivazione,
            },
            {
              label: "Altro",
              icon: PrimeIcons.FILE,
              style: { "font-size": "12px" },
              items: itemsAltro,
            },
          ];

          if (
            pratica.filePingTestUploaded ||
            pratica.fileSpeedTestUploaded ||
            pratica.fileVerbaleAttivazioneUploaded ||
            pratica.fotoCPEUploaded
          ) {
            allegatiFase2.push({
              label: "Scarica tutto",
              icon: "pi pi-download",
              style: { "font-size": "12px" },
              command: () => this.scaricaTuttaDocumentazione(pratica),
            });
          }
          if (pratica.statoFlowdyFase2 === "IN REWORK AZIENDA") {
            this.menuAzioniItems.push({
              label: "Note rework",
              icon: "icona-note_rework",
              style: { "font-size": "12px" },
              command: () => this.apriNoteRework(pratica),
            });
          }
          this.menuAzioniItems.push({
            label: "Documentazione",
            icon: "icona-files",
            style: { "font-weight": "bold", "font-size": "12px" },
            items: allegatiFase2,
          });
        }
        /*  if((!pratica.colocata ||  
              (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
              (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica))  ) ){ } */
        if (this.checkIfDeliverable(pratica)) {
          if (pratica.statoFlowdyFase2 === "IN REWORK AZIENDA") {
            this.menuAzioniItems.push({
              label: "Riconsegna",
              icon: "pi pi-send",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.consegnaPratica(pratica),
            });
          } else {
            this.menuAzioniItems.push({
              label: "Consegna",
              icon: "pi pi-send",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.consegnaPratica(pratica),
            });
          }
        }

        if (pratica.statoFlowdyFase2 === "CONSEGNATA") {
          /*   if((!pratica.colocata ||  
                (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica))  ) ){ } */
          this.menuAzioniItems.push({
            label: "Annulla consegna",
            icon: "pi pi-undo",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.annullaConsegna(pratica),
          });
        }

        if (
          pratica.statoFlowdyFase2 === "IN ATTESA CONFERMA TIM SUPPORT" ||
          pratica.statoFlowdyFase2 === "CONTROLLO TIM SUPPORT KO" ||
          pratica.statoFlowdyFase2 === "CONSEGNATA" ||
          pratica.statoFlowdyFase2 === "IN CARICO PRESIDIO" ||
          pratica.statoFlowdyFase2 === "PUBBLICATA" ||
          pratica.statoFlowdyFase2 === "APPROVATA"
        ) {
          if (
            !pratica.colocata ||
            (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
            (pratica.colocata &&
              pratica.colocataRuolo === "SECONDARIA" &&
              !this.checkCodiceInvioUgualeColocate(pratica))
          ) {
          }
          this.menuAzioniItems.push({
            label: "Scarica pacchetto",
            icon: "icona-scarica_pacchetto",
            style: { "font-size": "12px" },
            command: () => this.scaricaPacchettoPratica(pratica),
          });
        }
      }
    } else if (
      this.isPresidioSF ||
      this.isAdmin ||
      this.isSuperAdmin ||
      this.isDemo
    ) {
      //AZIONI SF & ADMIN

      this.menuAzioniItems.push({
        label: "Note",
        icon: "icona-note-presidio",
        style: { "font-size": "12px" },
        command: () => this.visualizzaNote(pratica),
      });
      if (pratica.showFase2) {
        this.menuAzioniItems.push({
          label: "Elimina show fase 2",
          icon: PrimeIcons.ERASER,
          style: { "font-size": "11.5px", "font-weight": "bold" },
          command: () => this.eliminaShowFase2(pratica),
        });
      }
      if (pratica.statoFlowdyFase2 === "IN ATTESA ODA") {
        this.menuAzioniItems.push({
          label: "Assegna ODA",
          icon: "icona-assegna-oda",
          style: { "font-weight": "bold", "font-size": "12px" },
          command: () => this.assegnaODA(pratica),
          disabled: this.isDemo,
        });
      }
      if (pratica.statoFlowdyFase2 === "DA ASSEGNARE") {
        this.menuAzioniItems.push({
          label: "Prendi in carico",
          icon: "icona-sf_in_carico",
          style: { "font-weight": "bold", "font-size": "12px" },
          command: () => this.openPrendiInCarico(pratica),
          disabled: this.isDemo,
        });
      }

      if (
        pratica.statoPF === "PRONTO" ||
        pratica.statoPF === "ROUTER INSTALLATO" ||
        pratica.statoPF === "SEDE ATTIVATA"
      ) {
        //SOLO SU PRATICHE CON PF PRONTO
        if (
          pratica.statoFlowdyFase2 === "ASSEGNATA" ||
          pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" ||
          pratica.statoFlowdyFase2 === "APPUNTAMENTO MANCATO"
        ) {
          /* if((!pratica.colocata ||  
                  (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                  (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioColocate(pratica)) 
                 ) ){} */

          if (pratica.servePermessoEntePubblico) {
            let itemsPermesso: any[] = [];
            itemsPermesso.push({
              label: "Carica",
              icon: PrimeIcons.UPLOAD,
              style: { "font-size": "12px" },
              command: () => this.caricaPermesso(pratica),
              disabled: this.isDemo,
            });
            if (pratica.permessoUploaded) {
              itemsPermesso.push({
                label: "Scarica",
                icon: PrimeIcons.DOWNLOAD,
                style: { "font-size": "12px" },
                command: () => this.scaricaPermesso(pratica),
              });
            }

            this.menuAzioniItems.push({
              label: "Permesso",
              icon: "icona-permessi",
              style: { "font-weight": "bold", "font-size": "12px" },
              items: itemsPermesso,
            });
          }

          if (
            !pratica.servePermessoEntePubblico ||
            (pratica.servePermessoEntePubblico && pratica.permessoUploaded)
          ) {
            let itemsAppuntamento: any[] = [];
            let labelComunicaData = "Comunica Data";
            if (pratica.dataAppuntamentoFase2) {
              labelComunicaData = "Cambia data";
            }
            itemsAppuntamento.push({
              label: labelComunicaData,
              icon: "icona-comunica-data",
              style: { "font-size": "12px" },
              command: () => this.comunicaDataAppuntamento(pratica),
              disabled: this.isDemo,
            });
            if (pratica.dataAppuntamentoFase2) {
              itemsAppuntamento.push({
                label: "Esito Installazione",
                icon: "icona-comunica-esito",
                style: { "font-size": "12px" },
                command: () => this.comunicaEsitoAppuntamento(pratica),
                disabled: this.isDemo,
              });
            }
            this.menuAzioniItems.push({
              label: "Appuntamento",
              icon: PrimeIcons.CALENDAR,
              style: { "font-weight": "bold", "font-size": "12px" },
              items: itemsAppuntamento,
            });
          }

          //}
        }
        if (
          (pratica.statoFlowdyFase2 === "ATTIVAZIONE KO FO" ||
            pratica.statoFlowdyFase2 === "ATTIVAZIONE KO CPE") &&
          pratica.statoPF === "PRONTO"
        ) {
          let itemsAppuntamento: any[] = [];
          itemsAppuntamento.push({
            label: "Comunica Nuova Data",
            icon: "icona-comunica-data",
            style: { "font-size": "12px" },
            command: () => this.comunicaDataAppuntamento(pratica),
            disabled: this.isDemo,
          });

          this.menuAzioniItems.push({
            label: "Appuntamento",
            icon: PrimeIcons.CALENDAR,
            style: { "font-weight": "bold", "font-size": "12px" },
            items: itemsAppuntamento,
          });
          //}
        }
        if (
          pratica.statoFlowdyFase2 !== "ASSEGNATA" &&
          pratica.statoFlowdyFase2 !== "IN ATTESA ODA" &&
          pratica.statoFlowdyFase2 !== "DA ASSEGNARE" &&
          pratica.statoFlowdyFase2 !== "APPUNTAMENTO MANCATO" &&
          pratica.statoFlowdyFase2 !== "APPUNTAMENTO FISSATO" &&
          pratica.statoFlowdyFase2 !== "ATTIVAZIONE KO FO" &&
          pratica.statoFlowdyFase2 !== "ATTIVAZIONE KO CPE"
        ) {
          this.menuAzioniItems.push({
            label: "Data Attivazione",
            icon: "icona-modifica-data_attivazione",
            style: { "font-weight": "bold", "font-size": "11.5px" },
            command: () => this.modificaDataAttivazione(pratica),
            disabled: this.isDemo,
          });
        }
        if (
          pratica.statoFlowdyFase2 === "CONTROLLO TIM SUPPORT OK" ||
          pratica.statoFlowdyFase2 === "INSTALLAZIONE EFFETTUATA" ||
          pratica.statoFlowdyFase2 === "IN REWORK AZIENDA" ||
          pratica.statoFlowdyFase2 === "CONSEGNATA" ||
          pratica.statoFlowdyFase2 === "IN VERIFICA SMARTFIBER"
        ) {
          /*  if((!pratica.colocata ||  
                (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioColocate(pratica)) 
                ) )
              { } */
          /*  this.menuAzioniItems.push({
                  label: "Data Attivazione",
                  icon: 'icona-modifica-data_attivazione',
                  style: { 'font-weight': 'bold',  'font-size': '11.5px'},
                  command: () => this.modificaDataAttivazione(pratica),
                }, ); */

          let itemsPingTest: any[] = [
            {
              label: "Carica",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () => this.caricaFile(pratica, "PING TEST"),
              disabled: this.isDemo,
            },
          ];
          if (pratica.filePingTestUploaded) {
            itemsPingTest.push(
              {
                label: "Scarica",
                icon: "pi pi-download",
                style: { "font-size": "12px" },
                command: () => this.scaricaFile(pratica, "PING_TEST", false),
              },
              {
                label: "Elimina tutti",
                icon: PrimeIcons.ERASER,
                style: { "font-weight": "bold", "font-size": "12px" },
                command: () =>
                  this.chiediEliminazioneTuttiFileCaricati(
                    pratica,
                    "PING_TEST",
                  ),
                disabled: this.isDemo,
              },
            );
          }
          let itemsSpeedTest: any[] = [
            {
              label: "Carica",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () => this.caricaFile(pratica, "SPEED TEST"),
              disabled: this.isDemo,
            },
          ];
          if (pratica.fileSpeedTestUploaded) {
            itemsSpeedTest.push(
              {
                label: "Scarica",
                icon: "pi pi-download",
                style: { "font-size": "12px" },
                command: () => this.scaricaFile(pratica, "SPEED_TEST", false),
              },
              {
                label: "Elimina tutti",
                icon: PrimeIcons.ERASER,
                style: { "font-weight": "bold", "font-size": "12px" },
                command: () =>
                  this.chiediEliminazioneTuttiFileCaricati(
                    pratica,
                    "SPEED_TEST",
                  ),
                disabled: this.isDemo,
              },
            );
          }

          let itemsVerbaleAttivazione: any[] = [
            {
              label: "Carica",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () => this.caricaDocumento(pratica, "ATTIVAZIONE"),
              disabled: this.isDemo,
            },
          ];
          if (pratica.fileVerbaleAttivazioneUploaded) {
            itemsVerbaleAttivazione.push({
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "12px" },
              command: () => this.scaricaDoc(pratica),
            });
          }
          let itemsDocumenti: any[] = [
            {
              label: "Verbale di Attivazione",
              style: { "font-size": "12px" },
              items: itemsVerbaleAttivazione,
            },
          ];
          let itemsFotoCPE: any[] = [
            {
              label: "Carica",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () =>
                pratica.fotoCPEUploaded
                  ? this.chiediSovrascritturaFotoCPE(pratica)
                  : this.caricaFotoCPE(pratica),
              disabled: this.isDemo,
            },
          ];
          if (pratica.fotoCPEUploaded) {
            itemsFotoCPE.push(
              {
                label: "Scarica",
                icon: "pi pi-download",
                style: { "font-size": "12px" },
                command: () => this.scaricaFotoCPE(pratica, false),
              },
              {
                label: "Elimina tutte",
                icon: PrimeIcons.ERASER,
                style: { "font-weight": "bold", "font-size": "12px" },
                command: () =>
                  this.chiediEliminazioneTuttiFileCaricati(pratica, "CPE"),
                disabled: this.isDemo,
              },
            );
          }

          let itemsFile: any[] = [
            {
              label: "Ping",
              style: { "font-size": "12px" },
              items: itemsPingTest,
            },
            {
              label: "Speed",
              style: { "font-size": "12px" },
              items: itemsSpeedTest,
            },
          ];

          let itemsAltro: any[] = [];
          itemsAltro.push({
            label: "Carica",
            icon: "pi pi-upload",
            style: { "font-size": "11px" },
            command: () => this.caricaFile(pratica, "ALTRO"),
          });
          if (pratica.fileAltriUploadedFase2) {
            itemsAltro.push(
              {
                label: "Scarica",
                icon: "pi pi-download",
                style: { "font-size": "11px" },
                command: () => this.scaricaFileAltri(pratica),
              },
              {
                label: "Elimina",
                icon: PrimeIcons.ERASER,
                style: { "font-weight": "bold", "font-size": "12px" },
                command: () =>
                  this.chiediEliminazioneTuttiAltriFileCaricati(pratica),
              },
            );
          }

          let allegatiFase2: any[] = [
            {
              label: "Test",
              icon: "icona-files",
              style: { "font-size": "12px" },
              items: itemsFile,
            },
            {
              label: "Foto CPE",
              icon: "icona-foto-cpe",
              style: { "font-size": "12px" },
              items: itemsFotoCPE,
            },
            {
              label: "Verbale",
              icon: "icona-docs",
              style: { "font-size": "12px" },
              items: itemsVerbaleAttivazione,
            },
            {
              label: "Altro",
              icon: PrimeIcons.FILE,
              style: { "font-size": "12px" },
              items: itemsAltro,
            },
          ];

          if (
            pratica.filePingTestUploaded ||
            pratica.fileSpeedTestUploaded ||
            pratica.fileVerbaleAttivazioneUploaded ||
            pratica.fotoCPEUploaded
          ) {
            allegatiFase2.push({
              label: "Scarica tutto",
              icon: "pi pi-download",
              style: { "font-size": "12px" },
              command: () => this.scaricaTuttaDocumentazione(pratica),
            });
          }
          /*  if((!pratica.colocata ||  
                  (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                  (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
                 ) ){ } */
          if (pratica.statoFlowdyFase2 === "IN REWORK AZIENDA") {
            this.menuAzioniItems.push({
              label: "Note rework",
              icon: "icona-note_rework",
              style: { "font-size": "12px" },
              command: () => this.apriNoteRework(pratica),
            });
            this.menuAzioniItems.push({
              label: "Riconsegna",
              icon: "pi pi-send",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.consegnaPratica(pratica),
              disabled: this.isDemo,
            });
          }

          this.menuAzioniItems.push({
            label: "Documentazione",
            icon: "icona-files",
            style: { "font-weight": "bold", "font-size": "12px" },
            items: allegatiFase2,
          });
        }

        if (
          pratica.statoFlowdyFase2 === "IN REWORK AZIENDA" ||
          pratica.noteVerbaleFase2 ||
          pratica.noteAllegatiFase2
        ) {
          this.menuAzioniItems.push({
            label: "Note rework",
            icon: "icona-note_rework",
            style: { "font-size": "12px" },
            command: () => this.apriNoteRework(pratica),
          });
        }

        if (
          this.checkIfDeliverable(pratica) &&
          pratica.statoFlowdyFase2 !== "IN REWORK AZIENDA"
        ) {
          /*   if((!pratica.colocata ||  
                (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
               ) ){ } */
          this.menuAzioniItems.push({
            label: "Consegna",
            icon: "pi pi-send",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.consegnaPratica(pratica),
            disabled: this.isDemo,
          });
        }
        if (pratica.statoFlowdyFase2 === "CONSEGNATA") {
          /*  this.menuAzioniItems.push(
                {
                  label: "Scarica documenti",
                  icon: 'pi pi-download',
                  style: {   'font-size': '12px'},
                  command: () => this.scaricaTuttaDocumentazione(pratica),
                }); */
          /*  if((!pratica.colocata ||  
                  (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                  (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
                 ) ){ } */
          this.menuAzioniItems.push({
            label: "Annulla consegna",
            icon: "pi pi-undo",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.annullaConsegna(pratica),
            disabled: this.isDemo,
          });
        }

        /*  if(pratica.statoFlowdyFase2 === "IN REWORK AZIENDA" ){
              if((!pratica.colocata ||  
                (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
               ) ){
               
               }
             
            } */

        if (pratica.statoFlowdyFase2 === "CONTROLLO TIM SUPPORT KO") {
          /*  if((!pratica.colocata ||  
                (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
               ) ){} */
          this.menuAzioniItems.push(
            {
              label: "Note TIM Support",
              icon: "icona-note_timSupport",
              style: { "font-size": "12px" },
              command: () => this.apriNoteTIMSupport(pratica),
            },
            {
              label: "Prendi in carico",
              icon: "icona-sf_in_carico",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.openPrendiInCarico(pratica),
              disabled: this.isDemo,
            },
          );
        }
      }

      if (
        pratica.statoPF === "PRONTO" ||
        pratica.statoPF === "ROUTER INSTALLATO" ||
        pratica.statoPF === "SEDE ATTIVATA"
      ) {
        if (
          pratica.statoFlowdyFase2 === "CONSEGNATA" ||
          pratica.statoFlowdyFase2 === "CONTROLLO TIM SUPPORT OK"
        ) {
          /*  if((!pratica.colocata ||  
                (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
               ) ){ } */
          this.menuAzioniItems.push({
            label: "Prendi in carico",
            icon: "icona-sf_in_carico",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.openPrendiInCarico(pratica),
            disabled: this.isDemo,
          });
        }
        if (pratica.statoFlowdyFase2 === "IN VERIFICA SMARTFIBER") {
          if (
            pratica.noteBocciaturaPresidio &&
            pratica.noteBocciaturaPresidio.length > 0
          ) {
            /* if((!pratica.colocata ||  
                  (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                  (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
                 ) ){ } */
            this.menuAzioniItems.push({
              label: "Mostra note presidio",
              icon: "icona-documentazione",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.apriNoteBocciaturaPresidio(pratica),
            });
          }
          /* this.menuAzioniItems.push(
                {
                  label: "Scarica documenti",
                  icon: 'pi pi-download',
                  style: {   'font-size': '12px'},
                  command: () => this.scaricaTuttaDocumentazione(pratica),
                }); */

          /*  if((!pratica.colocata ||  
                  (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                  (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
                 ) ){} */
          this.menuAzioniItems.push({
            label: "Valida consegna",
            icon: "icona-validazione-consegna",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.validaConsegna(pratica),
            disabled: this.isDemo,
          });
        }
        if (
          pratica.statoFlowdyFase2 === "IN ATTESA CONFERMA TIM SUPPORT" ||
          pratica.statoFlowdyFase2 === "CONTROLLO TIM SUPPORT KO" ||
          pratica.statoFlowdyFase2 === "IN CARICO PRESIDIO" ||
          pratica.statoFlowdyFase2 === "PUBBLICATA" ||
          pratica.statoFlowdyFase2 === "APPROVATA" ||
          pratica.statoFlowdyFase2 === "RESPINTA"
        ) {
          /* if((!pratica.colocata ||  
                  (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                  (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
                 ) ){ } */
          this.menuAzioniItems.push({
            label: "Scarica pacchetto",
            icon: "icona-scarica_pacchetto",
            style: { "font-size": "12px" },
            command: () => this.scaricaPacchettoPratica(pratica),
          });
        }

        if (pratica.statoFlowdyFase2 === "RESPINTA") {
          /* if((!pratica.colocata ||  
                (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
                (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
               ) ){  } */
          this.menuAzioniItems.push(
            {
              label: "Note respingimento",
              icon: "icona-note_rework",
              style: { "font-size": "12px" },
              command: () => this.apriNoteRespingimento(pratica),
            },
            {
              label: "Prendi in carico",
              icon: "icona-sf_in_carico",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.openPrendiInCarico(pratica),
              disabled: this.isDemo,
            },
          );
        }

        //
      }
      //this.logger.info(pratica.cui + " " + pratica.colocata + " " +pratica.colocataRuolo + " "+ this.checkCodiceInvioUgualeColocate(pratica));
      /*  if((!pratica.colocata ||  
              (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
              (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
             ) ){  } */
      this.menuAzioniItems.push(
        {
          label: "Cambia Stato",
          icon: "icona-forza_stato",
          style: { "font-weight": "bold", "font-size": "12px" },
          command: () => this.forzaStatoPratica(pratica),
          disabled: this.isDemo,
        },
        {
          label: "Resetta",
          icon: "icona-reset",
          style: { "font-weight": "bold", "font-size": "12px" },
          command: () => this.resettaPratica(pratica),
          disabled: this.isDemo,
        },
      );
    } else if (this.isPresidioTIM) {
      //AZIONI PRESIDIO TIM
      this.menuAzioniItems.push({
        label: "Note",
        icon: "icona-note-presidio",
        style: { "font-size": "12px" },
        //items:itemsNote,
        command: () => this.visualizzaNote(pratica),
      });
      /*  if((!pratica.colocata ||  
          (pratica.colocata && pratica.colocataRuolo ==='PRINCIPALE') || 
          (pratica.colocata && pratica.colocataRuolo ==='SECONDARIA' && !this.checkCodiceInvioUgualeColocate(pratica)) 
         ) ){} */
      this.menuAzioniItems.push({
        label: "Scarica pacchetto",
        icon: "icona-scarica_pacchetto",
        style: { "font-size": "12px" },
        command: () => this.scaricaPacchettoPratica(pratica),
      });

      this.menuAzioniItems.push({
        label: "Rifiuta consegna",
        icon: "icona-rifiuta_consegna",
        style: { "font-weight": "bold", "font-size": "11px" },
        command: () => this.rifiutaConsegna(pratica),
      });

      if (pratica.statoFlowdyFase2 === "IN CARICO PRESIDIO") {
        this.menuAzioniItems.push({
          label: "Invio Infratel",
          icon: "icona-invio-infratel",
          style: { "font-weight": "bold", "font-size": "11px" },
          command: () => this.comunicaInvioInfratelPratica(pratica),
        });
      }
      if (pratica.statoFlowdyFase2 === "PUBBLICATA") {
        this.menuAzioniItems.push({
          label: "Esito",
          icon: "icona-comunica_esito",
          style: { "font-weight": "bold", "font-size": "12px" },
          items: [
            {
              label: "Approvata",
              icon: "icona-fase1_approvata",
              style: { "font-size": "12px" },
              command: () => this.comunicaEsitoFase2(pratica, true),
            },
            {
              label: "Respinta",
              icon: "icona-fase1_respinta",
              style: { "font-size": "12px" },
              command: () => this.comunicaEsitoFase2(pratica, false),
            },
          ],
        });
      }
      // }
    } else if (this.isDirigenteFirmaPacchetti) {
      this.menuAzioniItems.push({
        label: "Note",
        icon: "icona-note-presidio",
        style: { "font-size": "12px" },
        command: () => this.visualizzaNote(pratica),
      });
    }
  }

  comunicaEsitoFase2(pratica: PraticaFlowdy2_Firestore, isApprovata: boolean) {
    if (isApprovata) {
      this.ref = this.dialogService.open(DialogAccettazioneInvioInfratel, {
        data: {
          pratica: pratica,
          fase: 2,
        },
        header:
          "Accettazione della FASE 2 della pratica " +
          pratica.cui.toUpperCase(),
        width: "60%",
        height: "60%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((bocciaturaFase2) => {
        if (bocciaturaFase2 && bocciaturaFase2.success) {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Accettazione della FASE 2 della pratica comuinicata!",
            life: 3000,
          });
        }
      });
    } else {
      this.ref = this.dialogService.open(ComunicaBocciatura, {
        data: {
          pratica: pratica,
          fase: 2,
        },
        header:
          "Indica le moditivazioni della bocciatura della FASE 2 della pratica " +
          pratica.cui.toUpperCase(),
        width: "60%",
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((bocciaturaFase2) => {
        if (bocciaturaFase2 && bocciaturaFase2.success) {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Bocciatura pratica comuinicata!",
            life: 3000,
          });
        }
      });
    }
  }

  scaricaReportPratiche() {
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, "0")}_${(today.getMonth() + 1).toString().padStart(2, "0")}_${today.getFullYear()}`;
    this.excelService.exportPraticheFase2ToExcel(
      this.pratiche,
      `pratiche_bando2_fase2_${formattedDate}.xlsx`,
      this.isImpresa,
    );
  }

  getColocateDiUnaPrincipale(
    codiceInfratel: String,
  ): Observable<PraticaFlowdy2_Firestore[]> {
    this.logger.info("--> getColocateDiUnaPrincipale " + codiceInfratel);

    const collectionRef = this.firestore.collection(
      this.collection_pratiche,
    ).ref;
    const query = collectionRef
      .where("bando", "==", "BANDO 2")
      .where("colocataScuolaPrincipale", "==", codiceInfratel);

    return new Observable<PraticaFlowdy2_Firestore[]>((observer) => {
      query
        .get()
        .then((qs) => {
          const risultati: PraticaFlowdy2_Firestore[] = [];
          qs.forEach((doc) => {
            const praticaColocata = doc.data() as PraticaFlowdy2_Firestore;
            risultati.push(praticaColocata);
          });

          observer.next(risultati);
          observer.complete();
        })
        .catch((error) => {
          // Emit un errore se la query fallisce
          observer.error(error);
        });
    });
  }

  async scaricaPacchettoPraticaColocata(pratica: PraticaFlowdy2_Firestore) {
    this.logger.info("** scaricaPacchettoPraticaColocata: inizio");
    const storage = getStorage();
    const zipPraticaPrincipale = new JSZip();
    this.isLoadingResults = true;
    const pathReferenceVerbale = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/IN/FASE_2/documentazione/" +
        pratica.cui +
        "_VERBALE_ATTIVAZIONE_FASE2.pdf",
    );
    const pathReferenceFoto = ref(
      storage,
      "pratiche/scuola/" + pratica.cui + "/IN/FASE_2/foto/",
    );
    const pathReferenceTestFiles = ref(
      storage,
      "pratiche/scuola/" + pratica.cui + "/IN/FASE_2/file/",
    );
    const pathReferenceAltriFile = ref(
      storage,
      "pratiche/scuola/" + pratica.cui + "/IN/FASE_2/altro/",
    );

    const pathReferencePermesso = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/IN/FASE_2/permesso/permesso_FASE2.pdf",
    );
    let filesToDownload = [pathReferenceVerbale];
    if (pratica.servePermessoEntePubblico && pratica.permessoUploaded) {
      filesToDownload.push(pathReferencePermesso);
    }
    const listResultFoto = await listAll(pathReferenceFoto);
    listResultFoto.items.forEach((item) => filesToDownload.push(item));
    const listResultFile = await listAll(pathReferenceTestFiles);
    listResultFile.items.forEach((item) => filesToDownload.push(item));
    const listResultAltriFile = await listAll(pathReferenceAltriFile);
    listResultAltriFile.items.forEach((item) => filesToDownload.push(item));

    const downloadPromises = [];

    this.logger.info(
      "** scaricaPacchettoPraticaColocata: passo alle secondarie",
    );
    let filesToDownloadSecondaria = [];
    const zipPraticaSecondaria = new JSZip();
    let cuiSecondaria: string = "";
    this.getColocateDiUnaPrincipale(pratica.cui).subscribe(
      (praticheColocate) => {
        this.logger.info(praticheColocate);
        praticheColocate.forEach(async (praticaColocata) => {
          cuiSecondaria = praticaColocata.cui;
          const pathReferenceVerbaleSecondaria = ref(
            storage,
            "pratiche/scuola/" +
              cuiSecondaria +
              "/IN/FASE_2/documentazione/" +
              cuiSecondaria +
              "_VERBALE_ATTIVAZIONE_FASE2.pdf",
          );
          const pathReferenceFotoSecondaria = ref(
            storage,
            "pratiche/scuola/" + cuiSecondaria + "/IN/FASE_2/foto/",
          );
          const pathReferenceTestFilesSecondaria = ref(
            storage,
            "pratiche/scuola/" + cuiSecondaria + "/IN/FASE_2/file/",
          );
          const pathReferenceAltriFileSecondaria = ref(
            storage,
            "pratiche/scuola/" + cuiSecondaria + "/IN/FASE_2/altro/",
          );
          const pathReferencePermessoSecondaria = ref(
            storage,
            "pratiche/scuola/" +
              cuiSecondaria +
              "/IN/FASE_2/permesso/permesso_FASE2.pdf",
          );
          const listResultFotoSecondaria = await listAll(
            pathReferenceFotoSecondaria,
          );
          listResultFotoSecondaria.items.forEach((item) =>
            filesToDownloadSecondaria.push(item),
          );
          const listResultFileSecondaria = await listAll(
            pathReferenceTestFilesSecondaria,
          );
          listResultFileSecondaria.items.forEach((item) =>
            filesToDownloadSecondaria.push(item),
          );
          const listResultAltriFileSecondaria = await listAll(
            pathReferenceAltriFileSecondaria,
          );
          listResultAltriFileSecondaria.items.forEach((item) =>
            filesToDownloadSecondaria.push(item),
          );
          filesToDownloadSecondaria.push(pathReferenceVerbaleSecondaria);
          if (
            praticaColocata.servePermessoEntePubblico &&
            praticaColocata.permessoUploaded
          ) {
            filesToDownloadSecondaria.push(pathReferencePermessoSecondaria);
          }
        });
      },
    );

    for (const pathRef of filesToDownload) {
      try {
        const blob = await getBlob(pathRef);
        if (blob) {
          if (pathRef.name.endsWith("_VERBALE_ATTIVAZIONE_FASE2.pdf")) {
            zipPraticaPrincipale.file("VERBALE_ATTIVAZIONE_FASE2.pdf", blob);
          } else {
            zipPraticaPrincipale.file(pathRef.name, blob);
          }

          downloadPromises.push(Promise.resolve());
        } else {
          this.logger.error(`Errore durante il download di ${pathRef.name}`);
          downloadPromises.push(Promise.reject());
        }
      } catch (error) {
        this.isLoadingResults = false;
        this.logger.info(pathRef.name);
      }
    }

    for (const pathRef of filesToDownloadSecondaria) {
      try {
        const blob = await getBlob(pathRef);
        if (blob) {
          if (pathRef.name.endsWith("_VERBALE_ATTIVAZIONE_FASE2.pdf")) {
            zipPraticaSecondaria.file("VERBALE_ATTIVAZIONE_FASE2.pdf", blob);
          } else {
            zipPraticaSecondaria.file(pathRef.name, blob);
          }

          downloadPromises.push(Promise.resolve());
        } else {
          this.logger.error(`Errore durante il download di ${pathRef.name}`);
          downloadPromises.push(Promise.reject());
        }
      } catch (error) {
        this.isLoadingResults = false;
        this.logger.info(pathRef.name);
      }
    }

    Promise.all(downloadPromises)
      .then(() => {
        let zipPraticaFinale = new JSZip();
        const zip1Promise = zipPraticaPrincipale
          .generateAsync({ type: "blob" })
          .then((blob) => {
            zipPraticaFinale.file(`${pratica.cui}.zip`, blob);
          });
        const zip2Promise = zipPraticaSecondaria
          .generateAsync({ type: "blob" })
          .then((blob) => {
            zipPraticaFinale.file(`${cuiSecondaria}.zip`, blob);
          });

        Promise.all([zip1Promise, zip2Promise])
          .then(() => {
            zipPraticaFinale
              .generateAsync({ type: "blob" })
              .then((finalBlob) => {
                saveAs(finalBlob, `${pratica.cui} - ${cuiSecondaria}.zip`);
                this.isLoadingResults = false;
              })
              .catch((error) =>
                console.error(
                  "Errore durante la creazione dello zip finale:",
                  error,
                ),
              );
          })
          .catch((error) =>
            console.error(
              "Errore durante l'aggiunta dei file allo zip finale:",
              error,
            ),
          );
      })
      .catch((error) =>
        console.error("Errore durante l'esecuzione delle promesse:", error),
      );

    this.isLoadingResults = false;
  }

  apriNoteRespingimento(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogNoteReworkFase2, {
      data: {
        pratica: pratica,
        isRespigimento: true,
      },
      header:
        "Note relative al RESPINGIMENTO della FASE 2 della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "70%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }

  chiediSovrascritturaFotoCPE(pratica: PraticaFlowdy2_Firestore) {
    this.selectedPratica = pratica;
    this.showSovrascritturaFotoCPEConfirmation = true;
  }

  comunicaInvioInfratelPratica(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogInvioInfratel, {
      data: {
        pratica: pratica,
        fase: 2,
      },
      header:
        "Comunicazione invio ad INFRATEL della FASE 2 della pratica " +
        pratica.cui.toUpperCase(),
      width: "50%",
      height: "80%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((invioFase1) => {
      if (invioFase1 && invioFase1.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Invio della pratica ad INFRATEL comuinicato!",
          life: 3000,
        });
      }
    });
  }

  eliminaShowFase2(pratica: PraticaFlowdy2_Firestore) {
    this.selectedPratica = pratica;
    this.showEliminaShowFase2Confirmation = true;
  }

  confermaEliminaShowFase2() {
    if (!this.selectedPratica) return;
    this.isLoadingResults = true;
    this.praticheService.nascondiFase2(this.selectedPratica.id).subscribe({
      next: () => {
        this.isLoadingResults = false;
        this.showEliminaShowFase2Confirmation = false;
        this.selectedPratica = null;
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Flag show fase 2 eliminato.",
          life: 5000,
        });
      },
      error: () => {
        this.messageService.add({
          life: 10000,
          severity: "error",
          summary: "Errore",
          detail: "Errore nell'eliminazione del flag show fase 2 della pratica",
        });
        this.isLoadingResults = false;
        this.showEliminaShowFase2Confirmation = false;
        this.selectedPratica = null;
      },
    });
  }

  visualizzaNote(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;

    this.praticheService.getNote(pratica.id).subscribe((notePratica) => {
      this.isLoadingResults = false;
      this.ref = this.dialogService.open(StoricoNotePraticaComponent, {
        data: {
          pratica: pratica,
          note: notePratica,
        },
        header: "NOTE della pratica " + pratica.cui,
        width: "50%",
        height: "85%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    });
  }

  apriNoteBocciaturaPresidio(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogNoteReworkFase1, {
      data: {
        pratica: pratica,
        isBocciaturaPresidio: true,
      },
      header:
        "Note indicate dal presidio per la bocciatura della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "70%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }

  rifiutaConsegna(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogPresidioTIMRifiutaPratica, {
      data: {
        pratica: pratica,
        fase: "2",
      },
      header:
        "Rifiuta la consegna della FASE 2 della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((rifiutoOK) => {
      if (rifiutoOK && rifiutoOK.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Consegna rifiutata !",
          life: 3000,
        });
      }
    });
  }

  async scaricaPacchettoPratica(pratica: PraticaFlowdy2_Firestore) {
    this.logger.info(
      "--> scaricaPacchettoPratica: " +
        pratica.cui +
        " - RUOLO COLOCATA: " +
        pratica.colocataRuolo +
        " - CODICE INVIO UGUALE: " +
        this.checkCodiceInvioUgualeColocate(pratica),
    );
    if (
      !pratica.colocata ||
      (pratica.colocata && pratica.colocataRuolo === "SECONDARIA") ||
      !this.checkCodiceInvioUgualeColocate(pratica)
    ) {
      const storage = getStorage();
      const zipPratica = new JSZip();

      this.isLoadingResults = true;
      const pathReferenceVerbale = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/IN/FASE_2/documentazione/" +
          pratica.cui +
          "_VERBALE_ATTIVAZIONE_FASE2.pdf",
      );
      const pathReferenceFoto = ref(
        storage,
        "pratiche/scuola/" + pratica.cui + "/IN/FASE_2/foto/",
      );
      const pathReferenceTestFiles = ref(
        storage,
        "pratiche/scuola/" + pratica.cui + "/IN/FASE_2/file/",
      );
      const pathReferenceAltriFile = ref(
        storage,
        "pratiche/scuola/" + pratica.cui + "/IN/FASE_2/altro/",
      );
      const pathReferencePermesso = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/IN/FASE_2/permesso/permesso_FASE2.pdf",
      );
      let filesToDownload = [pathReferenceVerbale];
      if (pratica.servePermessoEntePubblico && pratica.permessoUploaded) {
        filesToDownload.push(pathReferencePermesso);
      }
      const listResultFoto = await listAll(pathReferenceFoto);
      listResultFoto.items.forEach((item) => filesToDownload.push(item));
      const listResultFile = await listAll(pathReferenceTestFiles);
      listResultFile.items.forEach((item) => filesToDownload.push(item));
      const listResultAltriFile = await listAll(pathReferenceAltriFile);
      listResultAltriFile.items.forEach((item) => filesToDownload.push(item));
      const downloadPromises = [];
      for (const pathRef of filesToDownload) {
        try {
          const blob = await getBlob(pathRef);
          if (blob) {
            if (pathRef.name.endsWith("_VERBALE_ATTIVAZIONE_FASE2.pdf")) {
              zipPratica.file("VERBALE_ATTIVAZIONE_FASE2.pdf", blob);
            } else {
              zipPratica.file(pathRef.name, blob);
            }

            downloadPromises.push(Promise.resolve());
          } else {
            this.logger.error(`Errore durante il download di ${pathRef.name}`);
            downloadPromises.push(Promise.reject());
          }
        } catch (error) {
          this.isLoadingResults = false;
          this.logger.info(pathRef.name);
        }
      }
      Promise.all(downloadPromises).then(() => {
        zipPratica
          .generateAsync({ type: "blob" })
          .then((blob) => {
            saveAs(blob, pratica.cui + ".zip");
            this.isLoadingResults = false;
          })
          .catch((error) =>
            console.error("Errore durante la creazione dello zip:", error),
          );
      });
      this.isLoadingResults = false;
    } else {
      this.scaricaPacchettoPraticaColocata(pratica);
    }
  }

  comunicaDataAppuntamento(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogComunicaDataAppuntamentoFase2, {
      data: {
        pratica: pratica,
      },
      header: "Comunica data dell'appuntamento per la pratica " + pratica.cui,
      width: "50%",
      height: "30%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((dataAppuntamento) => {
      if (dataAppuntamento && dataAppuntamento.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Data appuntamento comunicata con successo!",
          life: 3000,
        });
        this.loadPratiche();
      }
    });
  }

  modificaDataAttivazione(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogModificaDataAttivazione, {
      data: {
        pratica: pratica,
      },
      header: "Modifica la data di ATTIVAZIONE della pratica " + pratica.cui,
      width: "60%",
      height: "35%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((esitoInstallazione) => {
      if (esitoInstallazione && esitoInstallazione.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Data di installazione del router modificata con successo!",
          life: 3000,
        });
        this.loadPratiche();
      }
    });
  }

  comunicaEsitoAppuntamento(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogComunicaEsitoAppuntamentoFase2, {
      data: {
        pratica: pratica,
      },
      header:
        "Comunica l'esito dell'installazione del router per la pratica " +
        pratica.cui,
      width: "70%",
      height: "75%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((esitoInstallazione) => {
      if (esitoInstallazione && esitoInstallazione.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Esito installazione router comunicata con successo!",
          life: 3000,
        });
        this.loadPratiche();
      }
    });
  }

  async scaricaPermesso(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    const storage = getStorage();
    let fileName =
      "pratiche/scuola/" +
      pratica.cui +
      "/IN/FASE_2/permesso/permesso_FASE2.pdf";
    let pathReferenceDoc = ref(storage, fileName);
    const blobFile = await getBlob(pathReferenceDoc);
    saveAs(blobFile, pratica.cui + "_permesso_fase2.pdf");
    this.isLoadingResults = false;
  }

  caricaFile(pratica: PraticaFlowdy2_Firestore, tipoFile: string) {
    let header = "Caricamento ";
    if (tipoFile === "PING TEST") {
      header += "del PING TEST";
    } else if (tipoFile === "ALTRO") {
      header += "di ALTRI FILE";
    } else {
      header += "dello SPEED TEST";
    }
    header += " della pratica " + pratica.cui.toUpperCase();
    if (tipoFile === "ALTRO") {
      this.ref = this.dialogService.open(DialogCaricaAltriFileFase2, {
        data: {
          pratica: pratica,
          tipoFile: tipoFile,
        },
        header: header,
        width: "50%",
        height: "30%",
      });
    } else {
      this.ref = this.dialogService.open(DialogCaricaFileFase2, {
        data: {
          pratica: pratica,
          tipoFile: tipoFile,
        },
        header: header,
        width: "50%",
        height: "50%",
      });
    }

    this.ref.onClose.subscribe((caricamentoDoc) => {
      this.logger.info(
        "--> caricamento file - pratica: " +
          pratica.cui +
          " - tipo file: " +
          tipoFile +
          " - successo: " +
          (caricamentoDoc && caricamentoDoc.success),
      );
      if (caricamentoDoc && caricamentoDoc.success) {
        if (caricamentoDoc.numeroFileCaricati) {
          if (caricamentoDoc.numeroFileCaricati == 1) {
            this.messageService.add({
              severity: "success",
              summary: "",
              detail: "1 file caricato con successo!",
              life: 3000,
            });
          } else {
            this.messageService.add({
              severity: "success",
              summary: "",
              detail:
                caricamentoDoc.numeroFileCaricati +
                " file caricati con successo!",
              life: 3000,
            });
          }
        } else {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: tipoFile + " caricato con successo!",
            life: 3000,
          });
        }
      }
    });
  }

  caricaFotoCPE(pratica: PraticaFlowdy2_Firestore) {
    this.showSovrascritturaFotoCPEConfirmation = false;
    this.ref = this.dialogService.open(DialogCaricaFoto, {
      data: {
        pratica: pratica,
        tipoFile: "CPE",
      },
      header:
        "Caricamento FOTO del CPE della pratica " + pratica.cui.toUpperCase(),
      width: "50%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((caricamentoFotoCPE) => {
      if (caricamentoFotoCPE && caricamentoFotoCPE.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Foto del cpe caricata con successo!",
          life: 3000,
        });
      }
    });
  }

  annullaConsegna(pratica: PraticaFlowdy2_Firestore) {
    this.showAnnullaConsegnaConfirmation = true;
    this.selectedPratica = pratica;
  }
  confermaAnnullamentoConsegnaPratica() {
    this.isLoadingResults = true;
    this.praticheService
      .annullaConsegnaFase2(this.selectedPratica.id)
      .subscribe({
        next: (v) => {
          this.isLoadingResults = false;
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Annullamento consegna FASE 2 avvenuto con successo!",
            life: 5000,
          });
          this.showAnnullaConsegnaConfirmation = false;
          this.selectedPratica = null;
          this.isLoadingResults = false;
          this.loadPratiche();
        },
        error: (e) => {
          this.messageService.add({
            life: 10000,
            severity: "error",
            summary: "Errore",
            detail:
              "Errore in fase di annullamento della consegna della FASE 2 della pratica",
          });
          this.isLoadingResults = false;
          this.showAnnullaConsegnaConfirmation = false;
          this.selectedPratica = null;
          this.isLoadingResults = false;
        },
        complete: () => {},
      });
  }

  consegnaPratica(pratica: PraticaFlowdy2_Firestore) {
    this.showDeliverConfirmation = true;
    this.selectedPratica = pratica;
  }

  confermaConsegnaPratica() {
    this.isLoadingResults = true;
    this.praticheService.consegnaFase2(this.selectedPratica.id).subscribe({
      next: (v) => {
        this.isLoadingResults = false;
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "FASE 2 della pratica consegnata!",
          life: 5000,
        });
        this.showDeliverConfirmation = false;
        this.selectedPratica = null;
        this.loadPratiche();
      },
      error: (e) => {
        this.messageService.add({
          life: 10000,
          severity: "error",
          summary: "Errore",
          detail: "Errore in fase di consegna della FASE 2 della pratica",
        });
        this.isLoadingResults = false;
        this.showDeliverConfirmation = false;
        this.selectedPratica = null;
      },
      complete: () => {},
    });
  }

  apriNoteRework(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogNoteReworkFase2, {
      data: {
        pratica: pratica,
      },
      header:
        "Note per il REWORK della FASE 2 della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "70%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }
  apriNoteTIMSupport(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogNoteReworkFase2, {
      data: {
        pratica: pratica,
        isTIMSupport: true,
      },
      header: "Note TIM SUPPORT per la pratica " + pratica.cui.toUpperCase(),
      width: "50%",
      height: "35%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }

  validaConsegna(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogVerificaConsegnaFase2, {
      data: {
        pratica: pratica,
      },
      header:
        "Validazione della consegna della FASE 2 della pratica " +
        pratica.cui.toUpperCase(),
      width: "80%",
      height: "95%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((consegnaValidata) => {
      if (consegnaValidata && consegnaValidata.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Consegna validata con successo!",
          life: 3000,
        });
        this.loadPratiche();
      }
    });
  }

  async scaricaTuttaDocumentazione(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    const storage = getStorage();
    if (pratica.filePingTestUploaded) {
      this.scaricaFile(pratica, "PING_TEST", true);
    }
    if (pratica.fileSpeedTestUploaded) {
      this.scaricaFile(pratica, "SPEED_TEST", true);
    }
    if (pratica.fotoCPEUploaded) {
      this.scaricaFotoCPE(pratica, true);
    }
    if (pratica.fileVerbaleAttivazioneUploaded) {
      this.scaricaDoc(pratica);
    }

    if (pratica.servePermessoEntePubblico && pratica.permessoUploaded) {
      this.scaricaPermesso(pratica);
    }
    if (pratica.fileAltriUploadedFase2) {
      this.scaricaFileAltri(pratica);
    }

    this.isLoadingResults = false;
  }

  async scaricaFotoCPE(pratica: PraticaFlowdy2_Firestore, isMassivo: boolean) {
    const storage = getStorage();
    this.isLoadingResults = true;
    const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_2/foto/`;
    try {
      const folderRef = ref(storage, folderPath);

      const fileList = await listAll(folderRef);
      const fileNames = fileList.items.map((item) => item.name); // Ottieni solo i nomi dei file
      for (const fileRef of fileNames) {
        const filePath = folderPath + "/" + fileRef;
        const fileReference = ref(storage, filePath);
        const blobFile = await getBlob(fileReference);
        saveAs(blobFile, fileRef);
      }
      if (!isMassivo) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail:
            pratica.numeroFotoCPEUploaded + " file scaricati con successo!",
          life: 3000,
        });
      }

      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "info",
        summary: "Attenzione!",
        detail: "Errore nel download dei file",
      });
    }
  }

  async scaricaFileAltri(pratica: PraticaFlowdy2_Firestore) {
    const storage = getStorage();
    const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_2/altro/`;
    this.logger.info(
      "--> scaricaFileAltri - pratica: " +
        pratica.cui +
        " - folderPath: " +
        folderPath,
    );
    const folderRef = ref(storage, folderPath);
    const fileList = await listAll(folderRef);
    const fileNames = fileList.items.map((item) => item.name); // Ottieni solo i nomi dei file
    for (const fileRef of fileNames) {
      const filePath = folderPath + "/" + fileRef;
      const fileReference = ref(storage, filePath);
      const blobFile = await getBlob(fileReference);
      saveAs(blobFile, fileRef);
    }
  }

  async chiediEliminazioneTuttiAltriFileCaricati(
    pratica: PraticaFlowdy2_Firestore,
  ) {
    this.selectedPratica = pratica;
    this.showEliminaFileAltriConfirmation = true;
  }

  async scaricaDoc(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    const storage = getStorage();
    let fileName =
      "pratiche/scuola/" +
      pratica.cui +
      "/IN/FASE_2/documentazione/" +
      pratica.cui;
    fileName += "_VERBALE_ATTIVAZIONE_FASE2.pdf";
    let pathReferenceDoc = ref(storage, fileName);
    const blobFile = await getBlob(pathReferenceDoc);
    saveAs(blobFile, pratica.cui + "_VERBALE_ATTIVAZIONE_FASE2.pdf");
    this.isLoadingResults = false;
  }

  caricaDocumento(pratica: PraticaFlowdy2_Firestore, tipoDocumento: string) {
    let header = "Caricamento del Verbale di ";
    if (tipoDocumento === "CONSEGNA") {
      header += "CONSEGNA ";
    } else {
      header += "ATTIVAZIONE ";
    }
    header += " della pratica " + pratica.cui.toUpperCase();

    this.ref = this.dialogService.open(DialogCaricaVerbaleFase2, {
      data: {
        pratica: pratica,
        tipoDoc: tipoDocumento,
      },
      header: header,
      width: "50%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((caricamentoDoc) => {
      if (caricamentoDoc && caricamentoDoc.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Verbale di " + tipoDocumento + " caricato con successo!",
          life: 3000,
        });
      }
    });
  }

  chiediEliminazioneTuttiFileCaricati(
    pratica: PraticaFlowdy2_Firestore,
    tipoFile: string,
  ) {
    this.selectedPratica = pratica;
    if (tipoFile === "PING_TEST") {
      this.showEliminaFilePINGConfirmation = true;
    } else if (tipoFile === "SPEED_TEST") {
      this.showEliminaFileSPEEDConfirmation = true;
    } else {
      this.showEliminaFileFotoCPEConfirmation = true;
    }
  }

  async eliminataTuttiFileCaricati(
    pratica: PraticaFlowdy2_Firestore,
    tipoFile: string,
  ) {
    const storage = getStorage();
    this.isLoadingResults = true;
    let folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_2/`;
    if (tipoFile !== "CPE") {
      folderPath += "file/";
    } else {
      folderPath += "foto/";
    }

    try {
      const folderRef = ref(storage, folderPath);
      const fileList = await listAll(folderRef);
      const deletePromises = [];
      let deletedFileCount = 0;

      for (const fileItem of fileList.items) {
        if (fileItem.name.startsWith(tipoFile)) {
          deletePromises.push(
            deleteObject(fileItem)
              .then(() => {
                deletedFileCount++;
              })
              .catch((deleteError) => {
                this.messageService.add({
                  severity: "error",
                  summary: "Errore",
                  detail: `Errore durante l'eliminazione del file ${fileItem.name}: ${deleteError.message}`,
                  life: 10000,
                });
              }),
          );
        }
      }
      await Promise.all(deletePromises);
      const docRef = this.firestore
        .collection(this.collection_pratiche)
        .doc(pratica.cui);
      if (tipoFile === "PING_TEST") {
        pratica.filePingTestUploaded = false;
        pratica.numeroFilePingtestUploaded = 0;
      } else if (tipoFile === "SPEED_TEST") {
        pratica.fileSpeedTestUploaded = false;
        pratica.numeroFileSpeedtestUploaded = 0;
      } else {
        pratica.fotoCPEUploaded = false;
        pratica.numeroFotoCPEUploaded = 0;
      }

      await docRef.update(pratica);
      this.showEliminaFilePINGConfirmation = false;
      this.showEliminaFileSPEEDConfirmation = false;
      this.showEliminaFileFotoCPEConfirmation = false;
      this.selectedPratica = null;
      this.messageService.add({
        severity: "success",
        summary: "Eliminazione completata",
        detail: `${deletedFileCount} file sono stati eliminati con successo.`,
        life: 10000,
      });

      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "error",
        summary: "Attenzione!",
        detail: `Errore nel recupero dei file: ${error.message}`,
      });
    }
  }

  async eliminataTuttiAltriFileCaricati(pratica: PraticaFlowdy2_Firestore) {
    const storage = getStorage();
    this.isLoadingResults = true;
    const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_2/altro/`;

    try {
      const folderRef = ref(storage, folderPath);
      const fileList = await listAll(folderRef);
      const deletePromises = [];
      let deletedFileCount = 0;

      for (const fileItem of fileList.items) {
        deletePromises.push(
          deleteObject(fileItem)
            .then(() => {
              deletedFileCount++;
            })
            .catch((deleteError) => {
              this.messageService.add({
                severity: "error",
                summary: "Errore",
                detail: `Errore durante l'eliminazione del file ${fileItem.name}: ${deleteError.message}`,
                life: 10000,
              });
            }),
        );
      }
      await Promise.all(deletePromises);
      const docRef = this.firestore
        .collection(this.collection_pratiche)
        .doc(pratica.cui);
      pratica.fileAltriUploadedFase2 = false;
      pratica.listaAltriFileUploadedFase2 = [];

      await docRef.update(pratica);
      this.showEliminaFileAltriConfirmation = false;
      this.selectedPratica = null;
      this.messageService.add({
        severity: "success",
        summary: "Eliminazione completata",
        detail: `${deletedFileCount} file sono stati eliminati con successo.`,
        life: 10000,
      });

      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "error",
        summary: "Attenzione!",
        detail: `Errore nel recupero dei file: ${error.message}`,
      });
    }
  }

  async scaricaFile(
    pratica: PraticaFlowdy2_Firestore,
    tipoFile: string,
    isMassivo: boolean,
  ) {
    const storage = getStorage();
    this.isLoadingResults = true;
    const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_2/file/`;
    try {
      const folderRef = ref(storage, folderPath);
      const fileList = await listAll(folderRef);
      const fileNames = fileList.items.map((item) => item.name); // Ottieni solo i nomi dei file
      for (const fileRef of fileNames) {
        if (fileRef.startsWith(tipoFile)) {
          const filePath = folderPath + "/" + fileRef;
          const fileReference = ref(storage, filePath);
          const blobFile = await getBlob(fileReference);
          saveAs(blobFile, fileRef);
        }
      }
      const numeroFile: number =
        tipoFile === "PING_TEST"
          ? pratica.numeroFilePingtestUploaded
          : pratica.numeroFileSpeedtestUploaded;
      if (!isMassivo) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: numeroFile + " file scaricati con successo!",
          life: 3000,
        });
      }
      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "info",
        summary: "Attenzione!",
        detail: "Errore nel download dei file",
      });
    }
  }

  resettaPratica(pratica: PraticaFlowdy2_Firestore) {
    this.showResettaPratica = true;
    this.selectedPratica = pratica;
  }
  confermaResetPratica() {
    this.isLoadingResults = true;
    this.praticheService.resetFase2(this.selectedPratica.id).subscribe({
      next: (v) => {
        this.isLoadingResults = false;
        this.showResettaPratica = false;
        this.selectedPratica = null;
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "FASE 2 resettata!",
          life: 5000,
        });
      },
      error: (e) => {
        this.messageService.add({
          life: 10000,
          severity: "error",
          summary: "Errore",
          detail: "Errore in fase di reset della FASE 2 della pratica",
        });
        this.isLoadingResults = false;
        this.showResettaPratica = false;
        this.selectedPratica = null;
      },
      complete: () => {},
    });
  }

  forzaStatoPratica(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogModificaStato, {
      data: {
        pratica: pratica,
        fase: 2,
      },
      header: "Cambio stato della Pratica " + pratica.cui,
      width: "50%",
      height: "40%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((statoUpdated) => {
      if (statoUpdated && statoUpdated.success) {
        this.isLoadingResults = false;
        this.messageService.add({
          severity: "success",
          summary: "",
          life: 10000,
          detail:
            "Stato della pratica " + pratica.cui + " aggiornato con successo",
        });
      }
    });
  }

  checkAppuntamentoPassato(pratica: PraticaFlowdy2_Firestore): boolean {
    if (pratica.dataAppuntamentoFase2) {
      const oggi = new Date();
      const dataAppuntamentoDaControllare = new Date(
        pratica.dataAppuntamentoFase2.toDate().getFullYear(),
        pratica.dataAppuntamentoFase2.toDate().getMonth(),
        pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
      );

      if (
        pratica.statoFlowdyFase2 === "APPUNTAMENTO MANCATO" &&
        pratica.dataAppuntamentoFase2 &&
        !pratica.installazioneRouterOk
      ) {
        if (dataAppuntamentoDaControllare < oggi) {
          return true;
        }
        return false;
      }
    }

    return false;
  }

  getTooltipAppuntamentoMancato(pratica: PraticaFlowdy2_Firestore): string {
    if (
      pratica.statoFlowdyFase2 === "APPUNTAMENTO MANCATO" &&
      pratica.dataAppuntamentoFase2 &&
      !pratica.installazioneRouterOk
    ) {
      if (pratica.dataAppuntamentoFase2.toDate() < new Date()) {
        const oggi = new Date();
        const dataAppuntamento = pratica.dataAppuntamentoFase2.toDate(); // Converte il Firestore Timestamp in un oggetto Date
        const diffTime = Math.abs(oggi.getTime() - dataAppuntamento.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) - 1; // Converte il tempo in giorni
        return (
          "Appuntamento fissato " +
          diffDays +
          " giorni fa e di cui non si è comunicato l'esito!"
        );
      }
      return "";
    }
    return "";
  }

  openPrendiInCarico(pratica: PraticaFlowdy2_Firestore): void {
    this.confirmationService.confirm({
      message: `Confermi di voler prendere in carico la FASE 2 della pratica ${pratica.cui}?`,
      header: "Presa in carico",
      icon: "pi pi-File-import",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        if (this.isImpresa) {
          let utente: Utente = new Utente();
          utente.id = Number(localStorage.getItem("idUtente"));
          this.praticheService
            .utentePrendeInCaricoFase2(this.selectedPratica.id, utente)
            .subscribe({
              next: (v) => {
                this.isLoadingResults = false;
                this.messageService.add({
                  severity: "success",
                  summary: "",
                  detail: "Pratica presa in carico con successo!",
                  life: 5000,
                });
                this.loadPratiche();
              },
              error: (e) => {
                this.messageService.add({
                  life: 10000,
                  severity: "error",
                  summary: "Errore",
                  detail: "Errore in fase di presa in carico della pratica",
                });
                this.isLoadingResults = false;
              },
              complete: () => {},
            });
        } else if (this.isPresidioSF) {
          if (pratica.statoFlowdyFase2 === "DA ASSEGNARE") {
            this.logger.info("PRESIDIO MA DA ASSEGNARE");
            let utente: Utente = new Utente();
            utente.id = Number(localStorage.getItem("idUtente"));
            this.praticheService
              .utentePrendeInCaricoFase2(this.selectedPratica.id, utente)
              .subscribe({
                next: (v) => {
                  this.isLoadingResults = false;
                  this.messageService.add({
                    severity: "success",
                    summary: "",
                    detail: "Pratica presa in carico con successo!",
                    life: 5000,
                  });
                  this.loadPratiche();
                },
                error: (e) => {
                  this.messageService.add({
                    life: 10000,
                    severity: "error",
                    summary: "Errore",
                    detail: "Errore in fase di presa in carico della pratica",
                  });
                  this.isLoadingResults = false;
                },
                complete: () => {},
              });
          } else {
            this.logger.info("PRESIDIO MA DA PRENDE IN CARICO");
            this.praticheService
              .presidioPrendeInCaricoFase2(this.selectedPratica.id)
              .subscribe({
                next: (v) => {
                  this.isLoadingResults = false;
                  this.messageService.add({
                    severity: "success",
                    summary: "",
                    detail: "Pratica presa in carico con successo!",
                    life: 5000,
                  });
                  this.loadPratiche();
                },
                error: (e) => {
                  this.messageService.add({
                    life: 10000,
                    severity: "error",
                    summary: "Errore",
                    detail: "Errore in fase di presa in carico della pratica",
                  });
                  this.isLoadingResults = false;
                },
                complete: () => {},
              });
          }
        }
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });
  }

  caricaPermesso(pratica: PraticaFlowdy2_Firestore) {
    let header = "Caricamento del PERMESSO ENTE PUBBLICO ";
    header += " per la pratica " + pratica.cui.toUpperCase();

    this.ref = this.dialogService.open(DialogCaricaPermessoFase2, {
      data: {
        pratica: pratica,
      },
      header: header,
      width: "50%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((caricamentoDoc) => {
      if (caricamentoDoc && caricamentoDoc.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail:
            "Permesso ente pubblico per la pratica " +
            pratica.cui +
            " caricato con successo!",
          life: 3000,
        });
      }
    });
  }

  aggiungiNota(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;

    this.ref = this.dialogService.open(CreaNotaPraticaComponent, {
      data: {
        pratica: pratica,
      },
      header: "Crea NOTA per la pratica " + pratica.cui,
      width: "50%",
      height: "55%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((creaNota) => {
      if (creaNota && creaNota.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Nota creata con successo!",
          life: 3000,
        });
      }
    });
    this.isLoadingResults = false;
  }

  openStoricoPratica(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    this.praticheService
      .getStoricoFase2(pratica.id)
      .subscribe((storicoPratica) => {
        this.isLoadingResults = false;
        if (storicoPratica && storicoPratica.length > 0) {
          this.logger.info(storicoPratica);
          this.ref = this.dialogService.open(StoricoPraticaComponent, {
            data: {
              pratica: pratica,
              storicoPratica: storicoPratica,
              fase: 2,
            },
            header: "Storico della FASE 2 della pratica " + pratica.cui,
            width: "50%",
            height: "85%",
            baseZIndex: 10000,
            closable: true,
            draggable: false,
          });
        } else {
          this.messageService.add({
            severity: "info",
            summary: "Attenzione!",
            detail: "La pratica non presenta STORICO",
          });
        }
      });
  }

  onMostraCompletatiChange(newValue: boolean): void {
    this.mostraPraticheCompletate = newValue;
    this.loadPratiche();
  }
  /* loadPratichePerPresidio(){
      const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
      let query;
      if(this.filterIsSet){
        if(this.filtroLotto){
          query= collectionRef.where("bando", "==", "BANDO 2")
          .where("lotto", "==", this.filtroLotto)
          .orderBy("codiceStatoInfratelFase2");
        }else if(this.filtroStatoInfratel){
          if(this.filtroLottoPerFase){
            query= collectionRef
            .where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLottoPerFase)
            .orderBy("codiceStatoInfratelFase2");

          }else {

            query= collectionRef
            .where("bando", "==", "BANDO 2")
            .where("codiceStatoInfratelFase1", "==", '1-6')
            .where("codiceStatoInfratelFase2", "==", this.filtroStatoInfratel)
            .orderBy("codiceStatoInfratelFase2");

          }
        }else  if(this.filtroInLavorazione){
          this.logger.info("[FASE 2 BANDO 2] PRESIDIO TIM LOADING FASE 2 BANDO 2 FILTRO PER IN LAVORAZIONE ");

          query= collectionRef
          .where("bando", "==", "BANDO 2")
          .where("codiceStatoInfratelFase1", "==", '1-6')
          //.where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
          .orderBy("codiceStatoInfratelFase2");
        }else  if(this.filtroOda){
          this.logger.info("[FASE 2 BANDO 2] PRESIDIO TIM LOADING FASE 2 BANDO 2 FILTRO PER ODA "+ this.filtroOda);
          if(this.filtroDaPagare){
            query= collectionRef
            .where("bando", "==", "BANDO 2")
            .where("codiceStatoInfratelFase1", "==", '1-6')
            .where("numeroOda", "==", Number(this.filtroOda))
          //  .where("importoPagatoFase1", "==", null)
           // .where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase2");
          }else{
            query= collectionRef.where("bando", "==", "BANDO 2").where("numeroOda", "==", Number(this.filtroOda)).orderBy("codiceStatoInfratelFase2");
          }
         
        }
        
      }else{
        this.logger.info("[FASE 2 BANDO 2] PRESIDIO TIM  LOADING FASE 2 BANDO 2 SENZA FILTRI");

        if(!this.mostraPraticheCompletate){
           query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("codiceStatoInfratelFase1", "==", '1-6')
          //  .where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase2");
          
        }else{
          query= collectionRef
          .where("bando", "==", "BANDO 2")
          .where("codiceStatoInfratelFase1", "==", '1-6')
          .orderBy("codiceStatoInfratelFase2");
        }
      }
    } */

  goBack() {
    // Naviga verso la home con i parametri per selezionare il tab corretto
    this.logger.info("[PRATICHE FASE 2] GO BACK FROM: " + this.paginaBack);
    /* let from = 'WIP_APPUNTAMENTI';
        if(this.filtroStatoFlowdy){
          from = 'DOCS_FASE2';
        }*/
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
      this.router.navigate([""], {
        queryParams: {
          bando: "2", // Bando 1
          from: this.paginaBack,
        },
        queryParamsHandling: "merge",
      }),
    );
    this.removeFilter();
  }

  loadPratiche() {
    this.isLoadingResults = false;
    const collectionRef = this.firestore.collection(
      this.collection_pratiche,
    ).ref;
    let query;
    if (this.isPresidioTIM) {
      if (this.filterIsSet) {
        if (this.filtroLotto) {
          this.logger.info(
            "[FASE 2 BANDO 2] PRESIDIO TIM LOADING FASE 2 BANDO 2 FILTRO PER LOTTO " +
              this.filtroLotto,
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
            //.where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase2");
        } else if (this.filtroStatoInfratel) {
          if (this.filtroLottoPerFase) {
            this.logger.info(
              "[FASE 2 BANDO 2] PRESIDIO TIM LOADING FASE 2 BANDO 2 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel +
                " E LOTTO " +
                this.filtroLottoPerFase,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              //.where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("codiceStatoInfratelFase2");
          } else {
            this.logger.info(
              "[FASE 2 BANDO 2] PRESIDIO TIM LOADING FASE 2 BANDO 2 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              // .where("codiceStatoInfratelFase1", "==", '1-6')
              .where("codiceStatoInfratelFase2", "==", this.filtroStatoInfratel)
              .orderBy("codiceStatoInfratelFase2");
          }
        } else if (this.filtroInLavorazione) {
          this.logger.info(
            "[FASE 2 BANDO 2] PRESIDIO TIM LOADING FASE 2 BANDO 2 FILTRO PER IN LAVORAZIONE ",
          );

          query = collectionRef
            .where("bando", "==", "BANDO 2")
            // .where("codiceStatoInfratelFase1", "==", '1-6')
            //.where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase2");
        } else if (this.filtroOda) {
          this.logger.info(
            "[FASE 2 BANDO 2] PRESIDIO TIM LOADING FASE 2 BANDO 2 FILTRO PER ODA " +
              this.filtroOda,
          );
          if (this.filtroDaPagare) {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              // .where("codiceStatoInfratelFase1", "==", '1-6')
              .where("numeroOda", "==", Number(this.filtroOda))
              //  .where("importoPagatoFase1", "==", null)
              // .where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
              .orderBy("codiceStatoInfratelFase2");
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("numeroOda", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase2");
          }
        } else if (this.filtroImpresa) {
          //this.logger.info("[PRATICHE FASE 1 LOADING PRATICHE FASE 1 FILTRO PER IMPRESA "+ this.filtroImpresa );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("idAzienda", "==", Number(this.filtroImpresa))
            .orderBy("codiceStatoInfratelFase2");
        }
      } else {
        this.logger.info(
          "[FASE 2 BANDO 2] PRESIDIO TIM  LOADING FASE 2 BANDO 2 SENZA FILTRI",
        );

        if (!this.mostraPraticheCompletate) {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            //  .where("codiceStatoInfratelFase1", "==", '1-6')
            //  .where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase2");
        } else {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            //  .where("codiceStatoInfratelFase1", "==", '1-6')
            .orderBy("codiceStatoInfratelFase2");
        }
      }
    } else if (this.isImpresa) {
      if (this.filterIsSet) {
        this.logger.info(
          "[FASE 2 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 2",
        );

        if (this.filtroLotto) {
          this.logger.info(
            "[FASE 2 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 2 FILTRO PER LOTTO " +
              this.filtroLotto,
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "!=", "2-6")
            .where(
              "idAziendaFase2",
              "==",
              this.userService.getUser().azienda.id,
            )
            .orderBy("codiceStatoInfratelFase2")
            .orderBy("cui");
        } else if (this.filtroStatoInfratel) {
          if (this.filtroLottoPerFase) {
            this.logger.info(
              "[FASE 2 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 2 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel +
                " E LOTTO " +
                this.filtroLottoPerFase,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where(
                "idAziendaFase2",
                "==",
                this.userService.getUser().azienda.id,
              )
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", this.filtroStatoInfratel)
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("cui");
          } else {
            this.logger.info(
              "[FASE 2 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 2 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", this.filtroStatoInfratel)
              .where(
                "idAziendaFase2",
                "==",
                this.userService.getUser().azienda.id,
              )
              .orderBy("cui");
          }
        } else if (this.filtroInLavorazione) {
          this.logger.info(
            "[FASE 2 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 2 FILTRO PER IN LAVORAZIONE ",
          );

          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where(
              "idAziendaFase2",
              "==",
              this.userService.getUser().azienda.id,
            )
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "!=", "2-6")
            .orderBy("codiceStatoInfratelFase2")
            .orderBy("cui");
        } else if (this.filtroOda) {
          this.logger.info(
            "[FASE 2 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 2 FILTRO PER ODA " +
              this.filtroOda,
          );
          if (this.filtroDaPagare) {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where(
                "idAziendaFase2",
                "==",
                this.userService.getUser().azienda.id,
              )
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("importoPagatoFase1", "==", null)
              .orderBy("codiceStatoInfratelFase1");
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where(
                "idAziendaFase2",
                "==",
                this.userService.getUser().azienda.id,
              )
              .where("numeroOda", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase1");
          }
        } else if (this.filtroPratica) {
          this.logger.info(
            "[FASE 2 BANDO 2] LOADING PRATICHE FASE 2 FILTRO PER PRATICA " +
              this.filtroPratica,
          );
          query = collectionRef
            .where(
              "idAziendaFase2",
              "==",
              this.userService.getUser().azienda.id,
            )
            .where("cui", "==", this.filtroPratica);
        } else if (this.filtroImpresa) {
          this.logger.info(
            "[PRATICHE FASE 2 LOADING PRATICHE FASE 1 FILTRO PER IMPRESA " +
              this.filtroImpresa,
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("idAziendaFase2", "==", Number(this.filtroImpresa))
            .orderBy("codiceStatoInfratelFase1");
        }
      } else {
        this.logger.info(
          "[FASE 2 BANDO 2] LOADING PRATICHE PER AZIENDA FASE 2 SENZA FILTRI",
        );

        if (!this.mostraPraticheCompletate) {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where(
              "idAziendaFase2",
              "==",
              this.userService.getUser().azienda.id,
            )
            //    .where("codiceStatoInfratelFase1", "==", '1-6')
            .where("codiceStatoInfratelFase2", "!=", "2-6")
            .orderBy("codiceStatoInfratelFase2")
            .orderBy("cui");
        } else {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where(
              "idAziendaFase2",
              "==",
              this.userService.getUser().azienda.id,
            )
            //   .where("codiceStatoInfratelFase1", "==", '1-6')
            .orderBy("codiceStatoInfratelFase2");
        }
      }
    } else if (this.isPM) {
      this.logger.info("[FASE 2 BANDO 2] LOADING PRATICHE PER PM FASE 2 ");
      query = collectionRef
        .where("bando", "==", "BANDO 2")
        //.where("lotto", "==", this.filtroLotto)
        .where("codiceStatoInfratelFase1", "!=", "1-6")
        .where("opereExtra", "==", true)
        // .where("dataEsitoPreventivo", "==",null )
        //.where("preventivoApprovato", "==",false )
        .where("statoFlowdyFase1", "==", "PREVENTIVO IN ATTESA")
        .orderBy("codiceStatoInfratelFase1");
    } else if (
      this.isPresidioSF ||
      this.isAdmin ||
      this.isSuperAdmin ||
      this.isDirigenteFirmaPacchetti ||
      this.isDemo
    ) {
      if (this.filterIsSet) {
        if (this.filtroLotto) {
          this.logger.info(
            "[FASE 2 BANDO 2] LOADING FASE 2 BANDO 2 FILTRO PER LOTTO " +
              this.filtroLotto,
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
            //   .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "!=", "2-6")
            .orderBy("codiceStatoInfratelFase2");
        } else if (this.filtroStatoInfratel) {
          if (this.filtroLottoPerFase) {
            this.logger.info(
              "[FASE 2 BANDO 2] LOADING FASE 2 BANDO 2 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel +
                " E LOTTO " +
                this.filtroLottoPerFase,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              //  .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "!=", "2-6")
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("codiceStatoInfratelFase2");
          } else {
            this.logger.info(
              "[FASE 2 BANDO 2] LOADING FASE 2 BANDO 2 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase2", "==", this.filtroStatoInfratel)
              .orderBy("codiceStatoInfratelFase2");
          }
        } else if (this.filtroInLavorazione) {
          this.logger.info(
            "[FASE 2 BANDO 2] LOADING FASE 2 BANDO 2 FILTRO PER IN LAVORAZIONE ",
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            //  .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "!=", "1-6")
            .orderBy("codiceStatoInfratelFase2");
        } else if (this.filtroOda) {
          this.logger.info(
            "[FASE 2 BANDO 2] LOADING FASE 2 BANDO 2 FILTRO PER ODA " +
              this.filtroOda,
          );
          if (this.filtroDaPagare) {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              //  .where("codiceStatoInfratelFase1", "==", '1-6')
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("importoPagatoFase1", "==", null)
              .orderBy("codiceStatoInfratelFase2");
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("numeroOda", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase2");
          }
        } else if (this.filtroImpresa) {
          if (this.filtroRegione) {
            this.logger.info(
              "[FASE 2 BANDO 2] LOADING PRATICHE FASE 2 FILTRO PER IMPRESA " +
                this.filtroImpresa +
                " FILTRO PER REGIONE " +
                this.filtroRegione,
            );
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("idAziendaFase2", "==", Number(this.filtroImpresa))
              .where("regione", "==", this.filtroRegione)
              .orderBy("statoFlowdyFase2")
              .orderBy("codiceStatoInfratelFase2");
          } else {
            if (this.filtroStatoFlowdy) {
              if (this.filtroStatoFlowdy === "APPUNTAMENTO MANCATO") {
                query = collectionRef
                  .where("bando", "==", "BANDO 2")
                  .where("idAzienda", "==", Number(this.filtroImpresa))
                  .where("statoFlowdyFase2", "==", "APPUNTAMENTO FISSATO")
                  .orderBy("statoFlowdyFase2")
                  .orderBy("codiceStatoInfratelFase2");
              } else if (
                this.filtroStatoFlowdy === "CONTROLLO TIM SUPPORT OK"
              ) {
                query = collectionRef
                  .where("bando", "==", "BANDO 2")
                  .where("idAziendaFase2", "==", Number(this.filtroImpresa))
                  // .where("statoFlowdyFase2", "==", 'APPUNTAMENTO FISSATO')
                  .orderBy("statoFlowdyFase2")
                  .orderBy("codiceStatoInfratelFase2");
              } else {
                query = collectionRef
                  .where("bando", "==", "BANDO 2")
                  .where("idAziendaFase2", "==", Number(this.filtroImpresa))
                  .where("statoFlowdyFase2", "==", this.filtroStatoFlowdy)
                  .orderBy("statoFlowdyFase2")
                  .orderBy("codiceStatoInfratelFase2");
              }
              this.logger.info(
                "[FASE 2 BANDO 2] LOADING PRATICHE FASE 2 FILTRO PER IMPRESA " +
                  this.filtroImpresa +
                  " FILTRO STATO FLOWDY " +
                  this.filtroStatoFlowdy,
              );
            } else {
              query = collectionRef
                .where("bando", "==", "BANDO 2")
                .where("idAziendaFase2", "==", Number(this.filtroImpresa))
                .orderBy("statoFlowdyFase1")
                .orderBy("codiceStatoInfratelFase2");
            }
          }
        } else if (this.filtroPratica) {
          this.logger.info(
            "[FASE 2 BANDO 2] LOADING PRATICHE FASE 2 FILTRO PER PRATICA " +
              this.filtroPratica,
          );
          query = collectionRef.where("cui", "==", this.filtroPratica);
        } else if (this.filtroStatoAttivazione) {
          if (this.filtroRegione) {
            this.logger.info(
              "[FASE 2 BANDO 2] LOADING PRATICHE FASE 2 FILTRO PER STATO ATTIVAZIONE " +
                this.filtroStatoAttivazione +
                " FILTRO PER REGIONE " +
                this.filtroRegione,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("regione", "==", this.filtroRegione)
              .orderBy("statoFlowdyFase2")
              .orderBy("codiceStatoInfratelFase2");
          } else {
            this.logger.info(
              "[FASE 2 BANDO 2] LOADING PRATICHE FASE 2 FILTRO PER STATO ATTIVAZIONE " +
                this.filtroStatoAttivazione,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .orderBy("statoFlowdyFase2")
              .orderBy("codiceStatoInfratelFase2");
          }
        } else if (this.filtroStatoFlowdy) {
          if (!this.filtroRegione) {
            this.logger.info(
              "[FASE 2 BANDO 2] LOADING PRATICHE FASE 2 FILTRO PER STATO FLOWDY " +
                this.filtroStatoFlowdy,
            );
            if (this.filtroStatoFlowdy === "APPUNTAMENTO MANCATO") {
              this.logger.info(
                "[FASE 2 BANDO 2] LOADING PRATICHE FASE 2 FILTRO PER STATO FLOWDY " +
                  this.filtroStatoFlowdy +
                  " FILTRO PER APPUNTAMENTO MANCATO",
              );
              query = collectionRef
                .where("bando", "==", "BANDO 2")
                .where("statoFlowdyFase2", "==", "APPUNTAMENTO FISSATO")
                .orderBy("statoFlowdyFase2")
                .orderBy("codiceStatoInfratelFase2");
            } else {
              this.logger.info(
                "[FASE 2 BANDO 2] LOADING PRATICHE FASE 2 FILTRO PER STATO FLOWDY " +
                  this.filtroStatoFlowdy,
              );
              query = collectionRef
                .where("bando", "==", "BANDO 2")
                .where("statoFlowdyFase2", "==", this.filtroStatoFlowdy)
                .orderBy("statoFlowdyFase2")
                .orderBy("codiceStatoInfratelFase2");
            }
          } else {
            this.logger.info(
              "[FASE 2 BANDO 2] LOADING PRATICHE FASE 2 FILTRO PER STATO FLOWDY " +
                this.filtroStatoFlowdy +
                " FILTRO PER REGIONE " +
                this.filtroRegione,
            );
            if (this.filtroStatoFlowdy === "APPUNTAMENTO MANCATO") {
              query = collectionRef
                .where("bando", "==", "BANDO 2")
                .where("regione", "==", this.filtroRegione)
                .where("statoFlowdyFase2", "==", "APPUNTAMENTO FISSATO")
                .orderBy("statoFlowdyFase2")
                .orderBy("codiceStatoInfratelFase2");
            } else {
              query = collectionRef
                .where("bando", "==", "BANDO 2")
                .where("regione", "==", this.filtroRegione)
                .where("statoFlowdyFase2", "==", this.filtroStatoFlowdy)
                .orderBy("statoFlowdyFase2")
                .orderBy("codiceStatoInfratelFase2");
            }
          }
        }
      } else {
        this.logger.info(
          "[FASE 2 BANDO 2] LOADING FASE 2 BANDO 2 SENZA FILTRI",
        );

        if (!this.mostraPraticheCompletate) {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            // .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "!=", "2-6")
            .orderBy("codiceStatoInfratelFase2");
        } else {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            //.where("codiceStatoInfratelFase1", "==", "1-6")
            .orderBy("codiceStatoInfratelFase2");
        }
      }
    }

    onSnapshot(query, (qs) => {
      this.logger.info(
        "[FASE 2 BANDO 2] FASE 2 BANDO 2 CARICATE " + qs.docs.length,
      );

      this.pratiche = [];
      this.praticheFiltrate = [];
      this.pratichePerPresidioTIM = [];
      this.isLoadingResults = false;
      qs.forEach((doc) => {
        let pratica = doc.data() as PraticaFlowdy2_Firestore;

        if (this.isPresidioTIM) {
          if (this.filtroStatoInfratel) {
            if (pratica.codiceStatoInfratelFase2 === this.filtroStatoInfratel) {
              this.pratiche.push(pratica);
              this.praticheFiltrate.push(pratica);
            }
          } else {
            this.pratichePerPresidioTIM.push(pratica);
            if (!this.mostraPraticheCompletate) {
              if (
                pratica.codiceStatoInfratelFase2 === "2-3" ||
                pratica.codiceStatoInfratelFase2 === "2-4"
              ) {
                this.pratiche.push(pratica);
                this.praticheFiltrate.push(pratica);
              }
            } else {
              if (
                pratica.codiceStatoInfratelFase2 === "2-3" ||
                pratica.codiceStatoInfratelFase2 === "2-4" ||
                pratica.codiceStatoInfratelFase2 === "2-6"
              ) {
                this.pratiche.push(pratica);
                this.praticheFiltrate.push(pratica);
              }
            }
          }
        } else {
          if (
            this.filterIsSet &&
            this.filtroImpresa &&
            !this.filtroStatoAttivazione
          ) {
            if (
              pratica.codiceStatoInfratelFase1 === "1-6" ||
              pratica.showFase2
            ) {
              this.pratiche.push(pratica);
              this.praticheFiltrate.push(pratica);
            }
          } else if (
            this.filterIsSet &&
            !this.filtroImpresa &&
            this.filtroStatoAttivazione
          ) {
            if (
              pratica.codiceStatoInfratelFase1 === "1-6" ||
              pratica.showFase2
            ) {
              switch (this.filtroStatoAttivazione) {
                case "noAppuntamentoMancaPF_noNTW":
                  if (
                    (!pratica.statoPF ||
                      pratica.statoPF === "IN ATTESA") &&
                    (!pratica.ntwFC ||
                      pratica.ntwFC === "" ||
                      pratica.ntwFC.length < 1)
                  ) {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "noAppuntamentoMancaPF_conNTW":
                  if (
                    pratica.statoPF === "IN ATTESA" &&
                    pratica.ntwFC &&
                    pratica.ntwFC !== "" &&
                    pratica.ntwFC.length >= 1
                  ) {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "noAppuntamentoMancaPF":
                  if (pratica.statoPF === "IN ATTESA") {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "noAppuntamentoPFPronto":
                  if (
                    pratica.statoPF === "PRONTO" &&
                    !pratica.dataAppuntamentoFase2
                  ) {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "appuntamentoFissato":
                  if (
                    pratica.statoPF === "PRONTO" &&
                    pratica.dataAppuntamentoFase2
                  ) {
                    const oggi = new Date();
                    const dataAppuntamentoDaControllare = new Date(
                      pratica.dataAppuntamentoFase2.toDate().getFullYear(),
                      pratica.dataAppuntamentoFase2.toDate().getMonth(),
                      pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
                    ); // Data di due giorni fa
                    if (
                      pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
                      pratica.dataAppuntamentoFase2 &&
                      !pratica.installazioneRouterOk &&
                      dataAppuntamentoDaControllare >= oggi
                    ) {
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                  }
                  break;
                case "appuntamentoScaduto":
                  if (
                    pratica.statoPF === "PRONTO" &&
                    pratica.dataAppuntamentoFase2
                  ) {
                    const oggi = new Date();
                    const dataAppuntamentoDaControllare = new Date(
                      pratica.dataAppuntamentoFase2.toDate().getFullYear(),
                      pratica.dataAppuntamentoFase2.toDate().getMonth(),
                      pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
                    ); // Data di due giorni fa
                    if (
                      pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
                      !pratica.installazioneRouterOk &&
                      dataAppuntamentoDaControllare < oggi
                    ) {
                      pratica.statoFlowdyFase2 = "APPUNTAMENTO MANCATO";
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                  }
                  break;
                case "attivazioneKO":
                  if (pratica.statoPF === "KO") {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "attivazioneOK":
                  if (pratica.statoPF === "SEDE ATTIVATA") {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "installazioneOK":
                  if (pratica.statoPF === "ROUTER INSTALLATO") {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                default:
                  break;
              }
            }
          } else if (
            this.filterIsSet &&
            this.filtroImpresa &&
            this.filtroStatoAttivazione
          ) {
            if (
              pratica.codiceStatoInfratelFase1 === "1-6" ||
              pratica.showFase2
            ) {
              switch (this.filtroStatoAttivazione) {
                case "noAppuntamentoMancaPF_noNTW":
                  if (
                    (!pratica.statoPF ||
                      pratica.statoPF === "IN ATTESA") &&
                    (!pratica.ntwFC ||
                      pratica.ntwFC === "" ||
                      pratica.ntwFC.length < 1)
                  ) {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "noAppuntamentoMancaPF_conNTW":
                  if (
                    pratica.statoPF === "IN ATTESA" &&
                    pratica.ntwFC &&
                    pratica.ntwFC !== "" &&
                    pratica.ntwFC.length >= 1
                  ) {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "noAppuntamentoMancaPF":
                  if (pratica.statoPF === "IN ATTESA") {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "noAppuntamentoPFPronto":
                  if (
                    pratica.statoPF === "PRONTO" &&
                    !pratica.dataAppuntamentoFase2
                  ) {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "appuntamentoFissato":
                  if (
                    pratica.statoPF === "PRONTO" &&
                    pratica.dataAppuntamentoFase2
                  ) {
                    const oggi = new Date();
                    const dataAppuntamentoDaControllare = new Date(
                      pratica.dataAppuntamentoFase2.toDate().getFullYear(),
                      pratica.dataAppuntamentoFase2.toDate().getMonth(),
                      pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
                    ); // Data di due giorni fa
                    if (
                      pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
                      pratica.dataAppuntamentoFase2 &&
                      !pratica.installazioneRouterOk &&
                      dataAppuntamentoDaControllare >= oggi
                    ) {
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                  }
                  break;
                case "appuntamentoScaduto":
                  if (
                    pratica.statoPF === "PRONTO" &&
                    pratica.dataAppuntamentoFase2
                  ) {
                    const oggi = new Date();
                    const dataAppuntamentoDaControllare = new Date(
                      pratica.dataAppuntamentoFase2.toDate().getFullYear(),
                      pratica.dataAppuntamentoFase2.toDate().getMonth(),
                      pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
                    ); // Data di due giorni fa
                    if (
                      pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
                      !pratica.installazioneRouterOk &&
                      dataAppuntamentoDaControllare < oggi
                    ) {
                      pratica.statoFlowdyFase2 = "APPUNTAMENTO MANCATO";
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                  }
                  break;
                case "attivazioneKO":
                  if (pratica.statoPF === "KO") {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "attivazioneOK":
                  if (pratica.statoPF === "SEDE ATTIVATA") {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                case "installazioneOK":
                  if (pratica.statoPF === "ROUTER INSTALLATO") {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                  break;
                default:
                  break;
              }
            }
          } else if (this.filterIsSet && this.filtroStatoFlowdy) {
            if (
              pratica.codiceStatoInfratelFase1 === "1-6" ||
              pratica.showFase2
            ) {
              if (
                this.filtroStatoFlowdy === "APPUNTAMENTO MANCATO" &&
                pratica.statoFlowdyFase1 !== "SOPRALLUOGO KO" &&
                pratica.codiceStatoInfratelFase1 === "1-6"
              ) {
                if (
                  pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
                  pratica.dataAppuntamentoFase2
                ) {
                  const oggi = new Date();
                  const dataAppuntamentoDaControllare = new Date(
                    pratica.dataAppuntamentoFase2.toDate().getFullYear(),
                    pratica.dataAppuntamentoFase2.toDate().getMonth(),
                    pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
                  ); // Data di due giorni fa
                  if (dataAppuntamentoDaControllare < oggi) {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                }
              } else if (
                this.filtroStatoFlowdy === "APPUNTAMENTO FISSATO" &&
                pratica.statoFlowdyFase1 !== "SOPRALLUOGO KO" &&
                pratica.codiceStatoInfratelFase1 === "1-6"
              ) {
                if (
                  pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
                  pratica.dataAppuntamentoFase2
                ) {
                  const oggi = new Date();
                  const dataAppuntamentoDaControllare = new Date(
                    pratica.dataAppuntamentoFase2.toDate().getFullYear(),
                    pratica.dataAppuntamentoFase2.toDate().getMonth(),
                    pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
                  ); // Data di due giorni fa
                  if (dataAppuntamentoDaControllare >= oggi) {
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                }
              } else if (
                this.filtroStatoFlowdy === "CONTROLLO TIM SUPPORT OK"
              ) {
                if (
                  pratica.statoFlowdyFase1 !== "SOPRALLUOGO KO" &&
                  pratica.codiceStatoInfratelFase1 === "1-6" &&
                  (pratica.statoFlowdyFase2 === "INSTALLAZIONE EFFETTUATA" ||
                    pratica.statoFlowdyFase2 === "CONTROLLO TIM SUPPORT OK")
                ) {
                  // this.logger.info("[FASE 2 BANDO 2] PRATICA "+ pratica.cui + " STATO FLOWDY "+ pratica.statoFlowdyFase2);
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                }
              } else {
                if (pratica.statoFlowdyFase2 === this.filtroStatoFlowdy) {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                }
              }
            } else {
            }
          } else {
            if (pratica.statoFlowdyFase1 !== "SOPRALLUOGO KO") {
              let praticaFromFS = pratica;

              if (pratica.dataAppuntamentoFase2) {
                const oggi = new Date();
                const dataAppuntamentoDaControllare = new Date(
                  pratica.dataAppuntamentoFase2.toDate().getFullYear(),
                  pratica.dataAppuntamentoFase2.toDate().getMonth(),
                  pratica.dataAppuntamentoFase2.toDate().getDate() + 2,
                ); // Data di due giorni fa
                if (
                  pratica.statoFlowdyFase2 === "APPUNTAMENTO FISSATO" &&
                  pratica.dataAppuntamentoFase2 &&
                  !pratica.installazioneRouterOk &&
                  dataAppuntamentoDaControllare < oggi
                ) {
                  pratica.statoFlowdyFase2 = "APPUNTAMENTO MANCATO";
                }
              }
              if (
                pratica.codiceStatoInfratelFase1 === "1-6" ||
                pratica.showFase2
              ) {
                this.pratiche.push(praticaFromFS);
                this.praticheFiltrate.push(praticaFromFS);
                this.pratichePerPresidioTIM.push(pratica);
              }
            }
          }
        }
      });
      this.filtraPratiche(null);
    });
  }

  filtraPratiche(event: any) {
    if (event && event.target) {
      this.praticheDT.filterGlobal(event.target.value, "contains");
    } else {
      if (
        this._filtroPratiche &&
        Object.keys(this._filtroPratiche).length !== 0
      ) {
        this.filterTabellaIsSet = true;
        this.praticheFiltrate = this.pratiche.filter(
          (pratica: PraticaFlowdy2_Firestore) => {
            // Esclusione pratiche senza statoPF quando si filtra per PF IN ATTESA
            if (
              this.filtroStatoAttivazione &&
              (this.filtroStatoAttivazione ===
                "noAppuntamentoMancaPF_conNTW" ||
                this.filtroStatoAttivazione === "noAppuntamentoMancaPF") &&
              (pratica.statoPF == null || pratica.statoPF === undefined)
            ) {
              return false;
            }

            const hasFiltroTipo =
              (this._filtroPratiche.tipo?.length ?? 0) > 0;
            if (hasFiltroTipo) {
              const tipoEff = pratica.tipoSedeEffettiva
                ? pratica.tipoSedeEffettiva.trim()
                : "";
              const tipoBase = pratica.tipoSede ? pratica.tipoSede.trim() : "";

              if (tipoEff && tipoEff.length > 0) {
                if (this._filtroPratiche.tipo.indexOf(tipoEff) === -1) {
                  return false;
                }
              } else if (tipoBase && tipoBase.length > 0) {
                if (this._filtroPratiche.tipo.indexOf(tipoBase) === -1) {
                  return false;
                }
              } else {
                return false;
              }
            }

            if (
              ((this._filtroPratiche.statoInfratel?.length ?? 0 > 0) &&
                this._filtroPratiche.statoInfratel.indexOf(
                  pratica.codiceStatoInfratelFase2,
                ) == -1) ||
              ((this._filtroPratiche.statoPratica?.length ?? 0 > 0) &&
                this._filtroPratiche.statoPratica.indexOf(
                  pratica.statoFlowdyFase2,
                ) == -1) ||
              ((this._filtroPratiche.regione?.length ?? 0 > 0) &&
                this._filtroPratiche.regione.indexOf(pratica.regione) == -1) ||
              //((this._filtroPratiche.impresa?.length ?? 0  > 0 ) &&  this._filtroPratiche.impresa.indexOf(pratica.idAzienda) == -1 )  ||
              ((this._filtroPratiche.impresa?.length ?? 0 > 0) &&
                this._filtroPratiche.impresa.indexOf(
                  pratica.idAziendaFase2 || pratica.idAzienda,
                ) == -1) ||
              ((this._filtroPratiche.statoProntofibra?.length ?? 0 > 0) &&
                this._filtroPratiche.statoProntofibra.indexOf(
                  pratica.statoPF,
                ) == -1)
            ) {
              return false;
            }

            return true;
          },
        );
      } else {
        this.praticheFiltrate = this.pratiche;
      }
    }
  }

  filtraPerStatoInfratel(statoInfratel: string) {
    if (!this.filterTabellaIsSet) {
      this.praticheDT.filterGlobal(statoInfratel, "contains");
      this.filterTabellaIsSet = true;
    } else {
      this.praticheDT.clear();
      this.filterTabellaIsSet = false;
    }
  }

  filtraPerOda(numeroOda: number) {
    if (!this.filterTabellaIsSet) {
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.praticheDT.filterGlobal(numeroOda, "contains");
        this.filterTabellaIsSet = true;
      }
    } else {
      this.praticheDT.clear();
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.filterTabellaIsSet = false;
      }
    }
  }

  filtraPerBando(oda: OdaAtFirestore) {
    if (!this.filterTabellaIsSet) {
      this.praticheDT.filterGlobal(oda.bando, "contains");
      this.filterTabellaIsSet = true;
    } else {
      this.praticheDT.clear();
      this.filterTabellaIsSet = false;
    }
  }
  filtraPerAzienda(azienda: String) {
    if (!this.filterTabellaIsSet) {
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.praticheDT.filterGlobal(azienda, "contains");
        this.filterTabellaIsSet = true;
      }
    } else {
      this.praticheDT.clear();
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.filterTabellaIsSet = false;
      }
    }
  }

  filtraPerLotto(lotto: string) {
    if (!this.filterTabellaIsSet) {
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.praticheFiltrate = this.pratiche.filter(
          (pratica: PraticaFlowdy2_Firestore) => {
            if (pratica.lotto === lotto) {
              return true;
            }

            return false;
          },
        );
        //this.praticheDT.filterGlobal(lotto, 'contains');
        this.filterTabellaIsSet = true;
      }
    } else {
      this.praticheDT.clear();
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.filterTabellaIsSet = false;
      }
    }
  }
  removeFilter() {
    if (
      this.filtroLotto ||
      this.filtroStatoInfratel ||
      this.filtroInLavorazione ||
      this.filtroOda ||
      this.filtroLottoPerFase ||
      this.filtroImpresa ||
      this.filtroPratica ||
      this.filtroStatoAttivazione ||
      this.filtroRegione
    ) {
      this.location.replaceState("/pratiche-bando2/fase-2");

      this.filterIsSet = false;
      this.filtroLotto = null;
      this.filtroStatoInfratel = null;
      this.filtroInLavorazione = null;
      this.filtroOda = null;
      this.filtroLottoPerFase = null;
      this.filtroImpresa = null;
      this.filtroStatoAttivazione = "";
      this.ragioneSocialeImpresa = "";
      this.filtroPratica = null;
      this.filtroStatoAttivazione = "";
      this.loadPratiche();
    } else {
      if (
        (this._filtroPratiche &&
          this._filtroPratiche.tipo &&
          this._filtroPratiche.tipo.length > 0) ||
        (this._filtroPratiche.statoInfratel &&
          this._filtroPratiche.statoInfratel.length > 0) ||
        (this._filtroPratiche.regione &&
          this._filtroPratiche.regione.length > 0) ||
        (this._filtroPratiche.statoPratica &&
          this._filtroPratiche.statoPratica.length > 0) ||
        (this._filtroPratiche.impresa &&
          this._filtroPratiche.impresa.length > 0) ||
        (this._filtroPratiche.statoProntofibra &&
          this._filtroPratiche.statoProntofibra.length > 0)
      ) {
        this._filtroPratiche.tipo = [];
        this._filtroPratiche.statoInfratel = [];
        this._filtroPratiche.statoPratica = [];
        this._filtroPratiche.regione = [];
        this._filtroPratiche.impresa = [];
        this._filtroPratiche.statoProntofibra = [];
      }
      this.filterTabellaIsSet = false;
      this.praticheFiltrate = this.pratiche;
      this.praticheDT.clear();
    }
  }

  mostraPratiche(oda: OdaAtFirestore, fase: string) {}

  setUserRole() {
    if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "ADMIN"
    ) {
      this.isAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SUPERADMIN"
    ) {
      this.isSuperAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SMARTFIBER"
    ) {
      this.isPresidioSF = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PRESIDIO"
    ) {
      this.isPresidioTIM = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
    ) {
      this.isImpresa = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_VERBALI"
    ) {
      this.isDirigenteFirmaVerbali = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
    ) {
      this.isDirigenteFirmaPacchetti = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PM"
    ) {
      this.isPM = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DEMO"
    ) {
      this.isDemo = true;
    }
  }

  checkConsegnabile(pratica: PraticaFlowdy2_Firestore): boolean {
    /*   this.logger.info("-> checkConsegnabile "+ pratica.cui + " "+ pratica.statoFlowdyFase2 + " "+ pratica.fotoCPEUploaded 
        + " "+ pratica.fileVerbaleAttivazioneUploaded
        + " "+ pratica.fileVerbaleAttivazioneUploaded
        + " "+ pratica.filePingTestUploaded
        + " "+ pratica.numeroFilePingtestUploaded
        + " "+ pratica.fileSpeedTestUploaded
        + " "+ pratica.numeroFileSpeedtestUploaded
      );
 */
    if (
      (pratica.statoFlowdyFase2 === "CONTROLLO TIM SUPPORT OK" ||
        pratica.statoFlowdyFase2 === "INSTALLAZIONE EFFETTUATA" ||
        pratica.statoFlowdyFase2 === "IN REWORK AZIENDA") &&
      pratica.fotoCPEUploaded &&
      pratica.fileVerbaleAttivazioneUploaded &&
      pratica.filePingTestUploaded &&
      pratica.numeroFilePingtestUploaded > 0 &&
      pratica.fileSpeedTestUploaded &&
      pratica.numeroFileSpeedtestUploaded > 0
    ) {
      return true;
    }
    return false;
  }

  checkIfButtonHasToBeShown(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      !pratica.colocata ||
      (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
      (pratica.colocata &&
        pratica.colocataRuolo === "SECONDARIA" &&
        !this.checkCodiceInvioUgualeColocate(pratica))
    ) {
      return true;
    } else {
      return false;
    }
  }

  checkIfDeliverable(pratica: PraticaFlowdy2_Firestore): boolean {
    return this.checkConsegnabile(pratica);
    /*  if(!pratica.colocata || 
          pratica.colocataRuolo==='SECONDARIA'){
            //this.logger.info("-> checkIfDeliverable "+ pratica.cui + " NON COLOCATA/SECONDARIA");

        return this.checkConsegnabile(pratica);
      }else {
        //this.logger.info("-> checkIfDeliverable "+ pratica.cui + " PRINCIPALE");

        if(pratica.colocataRuolo==='PRINCIPALE' && this.checkCodiceInvioUgualeColocate(pratica)){
          let praticheCololcate:PraticaFlowdy2_Firestore[] = this.getPraticheColocateDiUnaPrincipale(pratica.cui);
          let cololcataConsegnabile:boolean = false;
          if ( (pratica.statoFlowdyFase2 === 'INSTALLAZIONE EFFETTUATA' || pratica.statoFlowdyFase2 === 'IN REWORK AZIENDA')  && 
                pratica.fotoCPEUploaded &&
                pratica.fileVerbaleAttivazioneUploaded &&
                pratica.filePingTestUploaded && pratica.numeroFilePingtestUploaded > 0 &&
                pratica.fileSpeedTestUploaded && pratica.numeroFileSpeedtestUploaded > 0 
          ){
            praticheCololcate.forEach(cololcata => {
              cololcataConsegnabile = this.checkConsegnabile(cololcata);
            });

            return cololcataConsegnabile;
          }
        }else{
          return this.checkConsegnabile(pratica);
        }
        
        return false; 
      }
*/
  }

  getPrincipaleDiUnaColocata(pratica: PraticaFlowdy2_Firestore): string {
    return pratica.colocataScuolaPrincipale;
  }

  getDataInstallazioneRouterTooltip(pratica: PraticaFlowdy2_Firestore): string {
    if (pratica.installazioneRouterOk) {
      return (
        "Router installato in data " +
        this.utilService.formattaDataDaTimestampFirestore(
          pratica.dataAppuntamentoFase2,
        )
      );
    }
    let stringaErrore = "Tentativo di installazione fallito per problemi ";
    if (pratica.causaInstallazioneKO === "CPE") {
      stringaErrore += " al CPE ";
    } else {
      stringaErrore += " di RETE ";
    }
    stringaErrore += " (" + pratica.noteInstallazione + ") ";
    return stringaErrore;
  }
  getDataConfermaTSTooltip(pratica: PraticaFlowdy2_Firestore): string {
    if (pratica.installazioneRouterOk) {
      return (
        "Conferma ricevuta il " +
        this.utilService.formattaDataDaTimestampFirestore(
          pratica.dataConfermaTS,
        )
      );
    }
    return "";
  }
  getDataBocciaturaTSTooltip(pratica: PraticaFlowdy2_Firestore): string {
    if (pratica.installazioneRouterOk) {
      return (
        "KO ricevuto il " +
        this.utilService.formattaDataDaTimestampFirestore(
          pratica.dataBocciaturaTIMSupport,
        )
      );
    }
    return "";
  }

  importaEsitiConsegna() {
    this.importID = uuidv4();
    this.csvbox_importer_comunicaEsitiConsegnaBando2.setUser({
      importID: this.importID,
    });
    this.csvbox_importer_comunicaEsitiConsegnaBando2.openModal();
  }
  importaEsitiSupporto() {
    this.importID = uuidv4();
    this.csvbox_importer_esitiControlloTIMSupport.setUser({
      importID: this.importID,
    });
    this.csvbox_importer_esitiControlloTIMSupport.openModal();
  }
}
